import React, { useEffect, useState, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import "../css/Contractor.css";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Button,
  useMediaQuery,
  Drawer,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import CMilestoneList from "./CMilestoneList";
import { IoIosClose, IoMdClose } from "react-icons/io";
import { FaPencilAlt, FaUpload } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BarLoader } from "react-spinners";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Popover, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import axios from "axios";
import SendIcon from "@mui/icons-material/Send";
import BellIcon from "../image/bell-icon.png";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Description from "@mui/icons-material/Description";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ContractImg from "./../image/agreement.png";
import { Collapse } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Rack from "./../image/rack.png";

const initialChange = {
  status: "",
};

export default function Ownerhome() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState("");
  const [milestoneModel, setMilestoneModel] = useState(false);
  const [milestoneList, setMilestoneList] = useState(null);
  const [ownerinformation, setownerInformation] = useState(false);
  const [changeRequest, setChangeRequest] = useState(initialChange);
  const [ownerProjectList, setownerProjectList] = useState([]);
  const [selectedcontractor, setSelectedContractor] = useState({});
  const [projectname, setProjectname] = useState("");
  const [milestoneListdata, setMilestoneListdata] = useState([]);
  const [Changecontract, setChangeContract] = useState(false);
  const [ownerlog, setOwnerlog] = useState(true);
  const [loader, setLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [count, setCount] = useState({});
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [ContractChangeRequest, setContractChangeRequest] = useState([]);
  const [textAreaValues, setTextAreaValues] = useState([]);
  const [enableTextarea, setEnableTextarea] = useState(
    Array(ContractChangeRequest.length).fill(false)
  );
  const [changeprojectname, setChangeProjectname] = useState("");
  const [changeprojectid, setChangeProjectid] = useState("");

  const [chatview, setChatView] = useState(false);
  const [messages, setMessages] = useState([]);
  const [sendcomment, setSendcomment] = useState("");
  const [disabled, setDisabled] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [individualMileStone, setIndividualMileStone] = useState(null);
  const [milestonechangeRequestchat, setMilestonechangeRequestchat] = useState(
    []
  );
  const [scroll, setScroll] = useState(false);
  const [Nochat, setNoChat] = useState(false);
  const [notificationMap, setNotificationMap] = useState({});
  const [editIndex, setEditIndex] = useState(null);
  const [projectStatus, setProjectStatus] = useState("");
  const [paymentModal, setPaymentModal] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [mileStoneModal, setMileStoneModal] = useState(false);
  const [selectedMileStone, setSelectedMileStone] = useState([]);
  const [finalPaymnet, setFinalPayment] = useState({
    additional: null,
    balance: null,
    previous_milestone_balance_amount: null,
    reminder_message: "",
  });
  const [cancelLoader, setCancelLoader] = useState(false);
  const [milNum, setMilNum] = useState("");
  const [projectLevelTitle, setProjectLevelTitle] = useState(
    "Project Contract Approval"
  );
  const [acceptBtnEnable, setAcceptBtnEnable] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  const [files, setFiles] = useState([]);
  const [openSections, setOpenSections] = useState({});
  const [fileError, setFileError] = useState("");
  const [ProjectLevelViewModal, setProjectLevelViewModal] = useState(false);
  const [projectLevelContractorFiles, setProjectLevelContractorFiles] =
    useState([]);
  const [ContractPdf, setContractPdf] = useState(false);
  const [showDocuments, setShowDocuments] = useState(null);
  const [expanded, setExpanded] = useState({});
  const [mileDocs, setMileDocs] = useState(false);
  const [isContractLoader, setIsContractLoader] = useState(false);
  const [docHeader, setDocHeader] = useState("");
  const [loaderMsg, setLoaderMsg] = useState(false);
  const [projectLoaderMsg, setProjectLoaderMsg] = useState(
    "Fetching records..."
  );

  //File modal view
  const [selectedContractDoc, setSelectedContractDoc] = useState(null);
  const [ContractDocuments, setContractDocuments] = useState(false);

  //notification redirection
  const location = useLocation();
  const { notification } = location.state || {};

  const [notificationData, setNotificationData] = useState(null);
  const [cancelToken, setCancelToken] = useState(null);

  const toggleExpand = (msgIndex) => {
    setExpanded((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  useEffect(() => {
    setProjectLoaderMsg("Fetching records...");

    getownerProjectlist();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (notification) {
        setEditIndex(null);
        setIndividualMileStone(null);
        setNotificationData(notification);
        var pData = await axios.get("/cvault/get-project-detail/");
        pData = pData?.data?.data?.map((project, index) => {
          return { ...project, id: index + 1 };
        });
        const projectData = pData?.filter(
          (item) => item.project_id === notification?.project_id
        );

        const milestoneId = {
          project_id: notification?.project_id,
          milestone_id: notification?.milestone_id,
        };
        const response = await axios.post(
          "/cvault/milestone-details/",
          milestoneId,
          {
            headers: headers,
          }
        );

        const milestoneData = response?.data?.data || [];
        const index = milestoneData.findIndex(
          (item) => item.id === notification?.milestone_id
        );
        const miledata = milestoneData.filter(
          (item) => item.id === notification?.milestone_id
        );

        if (projectData?.[0]?.status === notification?.project_status) {
          if (
            (projectData?.[0]?.status === "Not Started" &&
              projectData?.[0]?.change_request?.status === "") ||
            projectData?.[0]?.change_request?.status === "Review"
          ) {
            setChatView(false);
            setLoaderMsg(true);

            MilestonechangeRequest(notification?.project_id);
            // setChangeContract(true);
            setChangeProjectid(notification?.project_id);
            setChangeProjectname(notification?.project_name);
            getPdfFile(notification?.project_id);
            setMilNum(miledata?.[0]?.milestone_number);
            if (notification?.cr_status) {
              setProjectLevelTitle("Project Change Request");
            } else {
              setProjectLevelTitle("Project Base Contract Approval");
            }
            if (notification?.cr_status) {
              setAcceptBtnEnable(true);
            } else {
              setAcceptBtnEnable(false);
            }
          } else if (projectData[0]?.status === "In Progress") {
            setChangeProjectid(notification?.project_id);
            setChangeProjectname(notification?.project_name);
            setSelectedProject(projectData);
            handleMilestoneDetailBtn(
              notification?.project_id,
              notification?.project_name
            );

            // setIndividualMileStone(miledata?.[0]);

            if (miledata[0]) {
              setIndividualMileStone({ id: miledata[0]?.id, row: miledata[0] });

              getFinalPayment(
                {
                  project: notification?.project_id,
                  id: notification?.milestone_id,
                },
                false
              );
            }

            MilestonechangeRequest(notification?.project_id, {
              id: miledata[0]?.id,
              row: miledata?.[0],
            });
            // handlegetchat(miledata?.[0], 0, notification?.project_id);
          }
        } else {
          // toast.warning(`Project Moved to ${projectData?.[0]?.status} state`);
          // toast.warning(`Action taken`);
        }
      }
      navigate(location.pathname, { replace: true, state: null });
    };
    fetchData();
  }, [notification]);
  useEffect(() => {
    if (selectedProject !== "") {
      setTimeout(() => {
        const targetElement = document.getElementById("expandOfProject");

        if (targetElement) {
          targetElement.scrollIntoView({ block: "center", behavior: "smooth" });
          targetElement.style.scrollMarginTop = "100px";
        }
      }, 500);
    }
  }, [selectedProject]);

  useEffect(() => {
    setFileError("");
  }, [milestoneModel, Changecontract, editIndex, newMessage]);

  useEffect(() => {
    setOpenSections({});
  }, [milestoneModel, Changecontract, editIndex]);

  // Handle file selection
  const handleFileUpload = (e) => {
    setFileError("");

    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024; // 200MB limit
    const allowedTypes = ["image", "video", "application/pdf", "text/plain"];

    let currentTotalSize = files.reduce((acc, file) => acc + file.file.size, 0);
    let validFiles = [];

    for (let file of selectedFiles) {
      if (files.some((f) => f.name === file.name)) {
        // toast.warning(`File ${file.name} is already included.`);
        setFileError(`File ${file.name} is already included.`);
        continue;
      }

      if (!allowedTypes.some((type) => file.type.startsWith(type))) {
        // toast.warning(`File type not supported: ${file.name}`);
        setFileError(`File type not supported: ${file.name}`);
        continue;
      }

      const inputElement = document.getElementById("chatInput");
      if (inputElement) {
        inputElement.focus();
      }

      if (currentTotalSize + file.size > maxTotalSize) {
        // toast.warning(
        //   `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        // );
        setFileError(
          `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        );

        break;
      }

      validFiles.push(file);
      currentTotalSize += file.size;
    }

    const newFiles = validFiles.map((file) => ({
      file,
      name: file.name,
      blob: new Blob([file], { type: file.type }),
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : file.type === "application/pdf"
        ? "pdf"
        : "text",
    }));

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    e.target.value = "";
  };

  // Remove a file
  const removeFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleDelete = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleToggle = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the specific section's open/closed state
    }));
  };

  const handleFileUploadChangeRequestProjectLevel = (e, index) => {
    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024; // 200MB limit
    const allowedTypes = ["image", "video", "application/pdf", "text/plain"];

    let currentTotalSize = ContractChangeRequest[index || 0]?.files.reduce(
      (acc, file) => acc + file.file.size,
      0
    );
    let validFiles = [];

    for (let file of selectedFiles) {
      if (
        ContractChangeRequest[index || 0]?.files.some(
          (f) => f.name === file.name
        )
      ) {
        // toast.warning(`File ${file.name} is already included.`);
        setFileError(`File ${file.name} is already included.`);

        continue;
      }

      // if (!allowedTypes.some((type) => file.type.startsWith(type))) {
      //   // toast.warning(`File type not supported: ${file.name}`);
      //   setFileError(`File type not supported: ${file.name}`);

      //   continue;
      // }
      const inputElement = document.getElementById("chatInput");
      if (inputElement) {
        inputElement.focus();
      }
      if (currentTotalSize + file.size > maxTotalSize) {
        // toast.warning(
        //   `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        // );
        setFileError(
          `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        );
        break;
      }

      validFiles.push(file);
      currentTotalSize += file.size;
    }

    const newFiles = validFiles.map((file) => ({
      file,
      name: file.name,
      blob: new Blob([file], { type: file.type }),
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : file.type === "application/pdf"
        ? "pdf"
        : file.type === "text/plain"
        ? "text"
        : "others",
    }));

    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) => {
        if (i !== index) return milestone; // Return unchanged items

        return {
          ...milestone,
          files: milestone.files ? [...milestone.files, ...newFiles] : newFiles,
        };
      })
    );
    e.target.value = "";
  };

  const handleDeleteProjectLevel = (fileIndex, editI) => {
    setContractChangeRequest((prevState) =>
      prevState.map((milestone, i) => {
        if (i !== editI) return milestone; // If not the editIndex, return the milestone unchanged

        // Remove the file from the 'files' array at the specified index
        const updatedFiles = milestone?.files.filter(
          (_, index) => index !== fileIndex
        );

        return {
          ...milestone,
          files: updatedFiles, // Update the files list
        };
      })
    );
  };
  const controllerRef = useRef(null); // Store AbortController instance

  const viewFiles = async (file, iframeShow = false) => {
    setFileError("");
    iframeShow && setShowDocuments(null);
    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);
      setIsLoader(false);

      const downfunc = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();
        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // ✅ Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // ✅ Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // ✅ Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // ✅ Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };

      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data);
          } else {
            downfunc(response);
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            setContractDocuments(true);
            setSelectedContractDoc(response.data.base64_content);
          } else {
            downfunc(response);
          }
        }
      }
    } catch (error) {
      setShowDocuments(null);
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setFileError("");
      } else {
        // toast.error(
        //   error?.response?.data?.error || "Unable to fetch the file."
        // );
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        setLoader(false);
        setIsLoader(false);
      }
    }
  };

  useEffect(() => {
    checkScroll();
  }, [openSections]);
  const containerRef = useRef(null);
  const leftBtnRef = useRef(null);
  const rightBtnRef = useRef(null);

  const checkScroll = () => {
    if (!containerRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;

    // Hide left button if at the start
    if (scrollLeft === 0) {
      if (leftBtnRef?.current?.style) leftBtnRef.current.style.display = "none";
    } else {
      if (leftBtnRef?.current?.style)
        leftBtnRef.current.style.display = "block";
    }

    // Hide right button if at the end
    if (scrollLeft + clientWidth >= scrollWidth - 1) {
      if (rightBtnRef?.current?.style)
        rightBtnRef.current.style.display = "none";
    } else {
      if (rightBtnRef?.current?.style)
        rightBtnRef.current.style.display = "block";
    }
  };

  const handleScrollLeft = (index) => {
    const fileContainer = document.getElementById(`scroll-container-${index}`);
    if (fileContainer) {
      fileContainer.scrollLeft -= 100; // Adjust the scroll amount as needed
    }
  };

  const handleScrollRight = (index) => {
    const fileContainer = document.getElementById(`scroll-container-${index}`);
    if (fileContainer) {
      fileContainer.scrollLeft += 100; // Adjust the scroll amount as needed
    }
  };

  const isAtStart = (index) => {
    const fileContainer = document.getElementById(`scroll-container-${index}`);
    return fileContainer ? fileContainer.scrollLeft === 0 : true;
  };

  const isAtEnd = (index) => {
    const fileContainer = document.getElementById(`scroll-container-${index}`);
    return fileContainer
      ? fileContainer.scrollLeft + fileContainer.clientWidth >=
          fileContainer.scrollWidth
      : true;
  };

  const viewChatFiles = (message, index) => {
    return (
      <div>
        {message?.files?.length > 0 && (
          <div
            style={{
              fontSize: "14px",
              textAlign: message?.user !== "Owner" ? "" : "end",
              margin: message?.user !== "Owner" ? "" : "0px 8px",
            }}
          >
            <button
              onClick={() => handleToggle(index)}
              style={{
                border: "none",
                background: "lightgray",
                borderRadius: "4px",
                backgroundColor: "rgb(247 247 247)",
                cursor: "pointer",
                marginTop: "5px",
                padding: "5px",
              }}
            >
              <div className="d-flex align-items-center">
                <div
                  style={{
                    fontWeight: 450,
                    fontSize: "13px",
                  }}
                >
                  View Files
                </div>

                <div className="ms-1">
                  {openSections[index] ? (
                    <KeyboardArrowUpIcon style={{ fontSize: "16px" }} />
                  ) : (
                    <KeyboardArrowDownIcon style={{ fontSize: "16px" }} />
                  )}
                </div>
              </div>
            </button>

            <div
              id={`files-${index}`}
              style={{
                display: openSections[index] ? "block" : "none",
                marginTop: "5px",
                width: "80%",
                marginLeft: message?.user !== "Owner" ? "" : "auto",
                justifyContent: message?.user !== "Owner" ? "" : "end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {/* Left Arrow Button */}
                {message?.files?.length > 2 && (
                  <button
                    ref={leftBtnRef}
                    onClick={() => handleScrollLeft(index)}
                    // disabled={isAtStart(index)} // Disable if at the start
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: "5px",
                      color: "gray",
                    }}
                  >
                    <KeyboardArrowLeftIcon />
                  </button>
                )}

                {/* Files Container */}
                <div
                  id={`scroll-container-${index}`}
                  ref={containerRef}
                  style={{
                    display: "flex",
                    gap: "10px",
                    overflowX: message?.files?.length > 2 ? "hidden" : "none", // Enable horizontal scrolling if more than 2 files
                    flexWrap: "nowrap",
                    maxWidth: "calc(100% - 10px)", // Adjust width to fit the left and right arrows
                    scrollBehavior: "smooth", // Add smooth scrolling behavior
                    flexShrink: 0, // Prevent shrinking
                    marginLeft: message?.user === "Owner" ? "auto" : "",
                  }}
                  onScroll={checkScroll}
                >
                  {message.files.map((item, fileIndex) => (
                    <div
                      key={fileIndex} // Make sure this is a unique key
                      className="preview-item group relative inline-block text-sm text-token-text-primary w-100"
                      style={{
                        borderRadius: "4px",
                        border: "1px solid lightgray",
                        padding: "3px",
                        width: "200px", // Set a fixed width for each file item
                      }}
                    >
                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl">
                        <div className="d-flex align-items-center">
                          <Tooltip placement="top" title="click to view image">
                            <div
                              style={{
                                // width: "100%",
                                // height: "80%",
                                color: "gray",
                                cursor: "pointer",
                              }}
                              className="d-flex flex-row align-items-center gap-2"
                              onClick={() => {
                                if (item?.type) {
                                  setContractDocuments(true);
                                  setSelectedContractDoc(
                                    URL.createObjectURL(item.blob)
                                  );
                                } else {
                                  viewFiles(item);
                                }
                              }}
                            >
                              <TextSnippetIcon
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  color: "rgb(128 175 215)",
                                  opacity: "0.9",
                                }}
                                className="relative h-10 w-10 shrink-0 overflow-hidden rounded-lg"
                              />
                            </div>
                          </Tooltip>

                          <div
                            style={{
                              fontSize: "13px",
                              marginLeft: "2px",
                              marginRight: "2px",
                              color: "gray",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (item?.type) {
                                setContractDocuments(true);
                                setSelectedContractDoc(
                                  URL.createObjectURL(item.blob)
                                );
                                // const newTab = window.open();
                                const newTab = false;
                                if (newTab) {
                                  if (item.type === "image") {
                                    newTab.document.write(
                                      `<img src="${URL.createObjectURL(
                                        item.blob
                                      )}" style="height:100%; display:flex; margin:auto" />`
                                    );
                                    newTab.document.title = "Image Preview";
                                  } else if (item.type === "video") {
                                    newTab.document.body.innerHTML = `<video controls autoplay style="width:100%; height:100vh;"><source src="${URL.createObjectURL(
                                      item.blob
                                    )}" type="${item.file.type}"></video>`;
                                    newTab.document.title = "Video Preview";
                                  } else if (
                                    item.type === "pdf" ||
                                    item.type === "text"
                                  ) {
                                    newTab.document.body.innerHTML = `<iframe src="${URL.createObjectURL(
                                      item.blob
                                    )}" style="width:100%; height:100vh; border:none;"></iframe>`;
                                    newTab.document.title = "PDF/Text Preview";
                                  }
                                }
                              } else {
                                viewFiles(item);
                              }
                            }}
                          >
                            {(() => {
                              const fileName = (item.name || item)
                                .split("/")
                                .pop()
                                .replace(" ", ""); // Extract filename from path
                              if (fileName.length > 9) {
                                return (
                                  fileName.slice(0, 5) +
                                  "..." +
                                  fileName.slice(-4)
                                );
                              }
                              return fileName.replace(" ", "");
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Right Arrow Button */}
                {message?.files?.length > 2 && (
                  <button
                    ref={rightBtnRef}
                    onClick={() => handleScrollRight(index)}
                    // disabled={isAtEnd(index)} // Disable if at the end
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: "5px",
                      color: "gray",
                    }}
                  >
                    <KeyboardArrowRightIcon />
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const iframeStyle = {
    width: "100%",
    height: "300px",
    border: "none", // Remove iframe border if needed
  };
  const iframeStyleContractPdf = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  const modelStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    // p: 2,
    // padding: "0px 16px 5px 16px",
    width: "85%",
    // height: "95%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "50%",
  };
  var popoverStyle = {
    border: " 0px solid rgba(0, 0, 0, .2)",
    borderRadius: "2px",
    fontFamily: "Roboto,sans-serif",
    boxShadow: " 0 2px 10px rgba(0, 0, 0, .2)",
    padding: "5px 15px 10px 15px",
    lineHeight: " 24px",
    fontSize: "14px",
    width: "200px",
    height: "23vh",
    background: "white",
    opacity: "0.9",
  };
  const columns = [
    { field: "id", headerName: "S.No", flex: 1, minWidth: 60, maxWidth: 80 },
    {
      headerName: "Project Name",
      field: "project_name",
      sortable: false,
      flex: 2,
      minWidth: 200,
      renderCell: (params) => <div>{params?.row?.name}</div>,
    },
    {
      field: "owner_payout",
      headerName: "Total Payout",
      flex: 0.5,
      minWidth: 150,
      renderCell: (params) =>
        params?.row?.owner_payout ? (
          <div className="MuiDataGrid-cellContent ms-3">
            {params?.row?.owner_payout}
          </div>
        ) : (
          <div className="MuiDataGrid-cellContent ms-3">-</div>
        ),
    },

    {
      field: "budget",
      headerName: "Total Contract Value",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div className="MuiDataGrid-cellContent ms-2">
          {params?.row?.budget}
        </div>
      ),
    },
    {
      field: "contractor",
      headerName: "Contractor",
      flex: 1,
      minWidth: 100,
      // maxWidth: 100,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={() => {
            contractorinfo(params?.row);
          }}
        >
          {params?.row?.details?.contractor_name}
        </div>
      ),
    },

    {
      headerName: "Documents",
      field: "project_files",
      sortable: false,
      flex: 1,
      minWidth: 70,
      maxWidth: 140,
      renderCell: (params) => (
        <div className="d-flex align -items-center justify-content-between">
          <Tooltip title="View Project Contract" placement="bottom">
            <div
              class="icon"
              style={{ color: "#F5AE41", cursor: "pointer" }}
              onClick={() => {
                getContractPdfFile(params?.row?.project_id);
              }}
            >
              <img
                src={ContractImg}
                alt="contract"
                style={{ width: "30px", height: "30px", objectFit: "cover" }}
              />
            </div>
          </Tooltip>
          <Tooltip
            title={
              params?.row?.additional_files?.length
                ? "View Project Documents"
                : "No Documents to view"
            }
            placement="bottom"
          >
            <div
              class="icon"
              style={{
                color: "#F5AE41",
                marginLeft: "20px",
                cursor: params?.row?.additional_files?.length ? "pointer" : "",
              }}
              onClick={() => {
                if (params?.row?.additional_files?.length) {
                  setChangeProjectname(params?.row?.name);
                  setDocHeader(`${params?.row?.name} - Project Documents`);

                  setMileDocs(false);
                  setProjectLevelContractorFiles(
                    params?.row?.additional_files || []
                  );
                  setProjectLevelViewModal(true);
                }
                setFileError("");
              }}
            >
              <img
                src={Rack}
                style={{
                  width: "30px",
                  height: "30px",
                  objectFit: "cover",
                  opacity: params?.row?.additional_files?.length ? 1 : 0.5,
                }}
                alt="project documents"
              />
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      headerName: "Milestones",
      field: "action",
      sortable: false,
      flex: 0.6,
      minWidth: 50,
      renderCell: (params) => (
        <div className="text-end">
          <button
            className="btn detail-btn ms-2"
            onClick={() => {
              setChangeProjectid(params?.row?.project_id);
              setChangeProjectname(params?.row?.name);
              setSelectedProject(params?.row);
              handleMilestoneDetailBtn(
                params?.row?.project_id,
                params?.row?.name
              );
            }}
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          >
            View
          </button>
        </div>
      ),
    },
    {
      field: "change_request",
      headerName: "Project Status",
      sortable: false,
      flex: 1.5,
      maxWidth: 150,
      renderCell: (params) =>
        params?.row?.status === "Not Started" &&
        params?.row?.change_request?.status === "" ? (
          <button
            className="btn detail-btnownwer"
            onClick={() => {
              setLoaderMsg(true);
              // setChangeContract(true);
              setChatView(false);
              setChangeProjectid(params?.row?.project_id);
              setIndividualMileStone(null);
              setEditIndex(null);
              MilestonechangeRequest(params?.row?.project_id);
              setChangeProjectname(params?.row?.name);
              getPdfFile(params?.row?.project_id);
              setMilNum(params?.row?.milestone_number);
              if (params?.row?.cr_status) {
                setProjectLevelTitle("Project Change Request");
              } else {
                setProjectLevelTitle("Project Contract Approval");
              }
              if (params?.row?.cr_status) {
                setAcceptBtnEnable(true);
              } else {
                setAcceptBtnEnable(false);
              }
            }}
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          >
            Review
          </button>
        ) : params?.row?.status === "Not Started" &&
          params?.row?.change_request?.status === "Review" ? (
          <button
            className="btn detail-btnownwer"
            onClick={() => {
              setChatView(false);
              setLoaderMsg(true);
              setIndividualMileStone(null);
              setEditIndex(null);

              MilestonechangeRequest(params?.row?.project_id);
              // setChangeContract(true);
              setChangeProjectid(params?.row?.project_id);
              setChangeProjectname(params?.row?.name);
              getPdfFile(params?.row?.project_id);
              setMilNum(params?.row?.milestone_number);
              if (params?.row?.cr_status) {
                setProjectLevelTitle("Project Change Request");
              } else {
                setProjectLevelTitle("Project Base Contract Approval");
              }
              if (params?.row?.cr_status) {
                setAcceptBtnEnable(true);
              } else {
                setAcceptBtnEnable(false);
              }
            }}
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          >
            Review
          </button>
        ) : params?.row?.status === "Awaiting Payment" ? (
          // <select
          //   className="select-form-control form-control"
          //   value={params?.row?.status}
          //   style={{ width: "100%", fontSize: "14px" }}
          //   onChange={(e) => {
          //     setLoader(true);
          //     handleChange(params);
          //   }}
          // >
          //   <option value="Awaiting Payment" disabled>
          //     Awaiting Payment
          //   </option>
          //   <option value="Payment Initiate">Payment Initiate</option>
          // </select>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "gray",
            }}
          >
            Admin Review
          </div>
        ) : (
          <div
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "gray",
            }}
          >
            {params?.row?.status === "Not Started"
              ? params?.row?.change_request?.status
              : params?.row?.status === "In Progress"
              ? "Execution Phase"
              : params?.row?.status}
          </div>
        ),
    },
    {
      field: "change",
      headerName: "",
      sortable: false,
      flex: 0.2,
      minWidth: 40,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={(e) => {
            setCount(params?.row?.milestone_status_count);
            handleClick(e);
          }}
        >
          <BsThreeDotsVertical />
        </div>
      ),
    },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getownerProjectlist = async () => {
    setProjectLoaderMsg("Fetching records...");

    try {
      var ownerdata = await axios.get(`/cvault/get-project-detail/`);
      ownerdata = ownerdata?.data?.data.map((project, index) => {
        return { ...project, id: index + 1 };
      });
      setownerProjectList(ownerdata);
      setTimeout(() => {
        setProjectLoaderMsg("No projects found");
      }, 100);
    } catch (error) {
      setProjectLoaderMsg("No projects found");
      // toast.error("Something went wrong ");
    }
  };

  const contractorinfo = (row) => {
    setSelectedContractor(row);
    setownerInformation(true);
  };

  const headerClassName = "custom-header";

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };

  const getContractPdfFile = async (id) => {
    setLoader(true);
    try {
      const data = {
        project: id,
      };
      const response = await axios.post("/cvault/get-pdf/", data, {
        headers: headers,
      });

      setLoader(false);
      setContractPdf(true);
      setSelectedPdfFile(response?.data?.base64_content);
    } catch (error) {
      setLoader(false);
      setSelectedPdfFile(null);
      toast.error(
        error?.response?.data?.error || "Unable to fetch the contract file."
      );
    }
  };

  const getPdfFile = async (id) => {
    setIsContractLoader(true);
    try {
      const data = {
        project: id,
      };
      const response = await axios.post("/cvault/get-pdf/", data, {
        headers: headers,
      });
      setChangeContract(true);
      setLoaderMsg(false);

      setSelectedPdfFile(response?.data?.base64_content || null);
      setIsContractLoader(false);
    } catch (error) {
      setSelectedPdfFile(null);
      setLoaderMsg(false);
      setChangeContract(true);

      setIsContractLoader(false);
      // toast.error("Something went wrong ");
    }
  };

  const handleMilestoneModal = async (id) => {
    setProjectLoaderMsg("Fetching records...");
    try {
      const milestonedata = await axios.get(
        `/cvault/get-milestones/?project_id=${id || changeprojectid}`
      );
      setMilestoneListdata(milestonedata?.data?.data);
      setTimeout(() => {
        setProjectLoaderMsg("No milestones found");
      }, 100);

      setProjectStatus(milestonedata?.data?.project_status);
      getownerProjectlist();
    } catch (error) {
      setProjectLoaderMsg("No milestones found");

      // toast.error("Something went wrong ");
    }
  };

  const changeRequestData = ContractChangeRequest.map((milestone, index) => ({
    milestone: milestone.id,
    milestone_name: milestone.milestone,
    description: milestone.milestone_description,
    price: milestone.milestone_amount,
    comment: textAreaValues[index] || "",
  }));

  const handleMilestoneDetailBtn = (id, name) => {
    setProjectname(name);
    handleMilestoneModal(id);
    setMilestoneList(id);
  };

  useEffect(() => {}, []);
  const Acceptproject = async () => {
    try {
      setChangeContract(false);
      setLoader(true);
      const data = {
        changeRequestData,
        project: changeprojectid,
      };
      setLoader(true);
      const response = await axios.post("/cvault/contract-accept/", data, {
        headers: headers,
      });
      setLoader(false);
      toast.success(
        "Contract accepted by Owner. Acceptance intimated to Contractor over mail to start the project"
      );
      getownerProjectlist();
      if (individualMileStone !== null) {
        handleMilestoneModal(changeprojectid);
      }

      // setChangeProjectid("");
      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
    } catch (error) {
      setLoader(false);
      // setChangeProjectid("");
      setChangeContract(false);
      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
      console.error("Error submitting form:", error);
      toast.error("Please try again later.");
    }
  };

  const handlegetchat = async (milestone, index, prj = null) => {
    setEditIndex(index);
    setMilestonechangeRequestchat(milestone);
    setMessages([]);
    setNewMessage("");
    setSendcomment("");
    setNoChat(false);
    const data = {
      project_id: prj || changeprojectid,
      milestone_id: milestone?.id,
    };

    try {
      const response = await axios.post("/cvault/change-request-chat/", data, {
        headers: headers,
      });
      if (
        Array.isArray(response?.data?.data) &&
        response?.data?.data?.length === 0
      ) {
        setSendcomment(response?.data.status);
        setNoChat(true);
      } else {
        setSendcomment(response?.data.status);
        setMessages(response?.data?.data);
      }
      setChatView(true);
    } catch (error) {
      toast.error("Unable to retrieve chat details. Please try again later.");
    }
  };

  const cancelCRRequest = async (mile) => {
    setLoader(true);

    try {
      const payload = {
        project_id: individualMileStone?.row?.project || changeprojectid,
        milestone_id: mile?.id || individualMileStone?.row?.id,
      };
      const response = await axios.post(
        "/cvault/cancel-change-request/",
        payload,
        {
          headers: headers,
        }
      );
      setPaymentModal(false);
      // setChangeContract(false);
      setMileStoneModal(false);
      setLoader(false);
      getownerProjectlist();
      handleMilestoneModal(changeprojectid);

      setFinalPayment({
        additional: null,
        balance: null,
        reminder_message: "",
        previous_milestone_balance_amount: null,
      });
      if (individualMileStone === null) {
        toast.success(
          `Change Request denied for Milestone(${mile?.milestone_number || 1})`
        );
        MilestonechangeRequest(
          changeprojectid,
          individualMileStone !== null ? individualMileStone : null
        );
        handlegetchat(mile, editIndex || 0);
      } else {
        toast.success(
          `Change Request denied for Milestone(${
            individualMileStone?.row?.milestone_number || 1
          })`
        );
        setChangeContract(false);
      }
    } catch (error) {
      setPaymentModal(false);
      setChangeContract(false);
      setMileStoneModal(false);
      setLoader(false);
    }
  };

  const individualMileStoneAccept = async (mile) => {
    setLoader(true);

    try {
      const payload = {
        project_id: changeprojectid,
        milestone_id: mile?.id,
      };
      const response = await axios.post(
        "/cvault/change-request-accept/",
        payload,
        {
          headers: headers,
        }
      );
      setLoader(false);
      // setChangeContract(false);
      setMileStoneModal(false);
      setPaymentModal(false);
      getownerProjectlist();
      handleMilestoneModal(changeprojectid);
      toast.success(
        `Change Request accepted for Milestone(${mile?.milestone_number || 1})`
      );
      setIndividualMileStone(null);

      //Not closing the modal here on project level
      if (individualMileStone === null) {
        MilestonechangeRequest(
          changeprojectid,
          individualMileStone !== null ? individualMileStone : null
        );
        handlegetchat(mile, editIndex || 0);
      } else {
        setChangeContract(false);
      }
    } catch (error) {
      setLoader(false);
      setChangeContract(false);
      setMileStoneModal(false);
      setPaymentModal(false);
    }
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === "") {
      return;
    }
    setMessages([
      ...messages,
      {
        chat: newMessage,
        user: "Owner",
        files: ContractChangeRequest[editIndex || 0]?.files,
      },
    ]);
    setNoChat(false);
    setNewMessage("");
  };

  const sendchat = async () => {
    if (newMessage?.length > 0) {
      setLoader(true);
      const data = {
        project_id: changeprojectid,
        milestone_id: milestonechangeRequestchat?.id,
        comment: newMessage,
      };

      // Create FormData object
      const formData = new FormData();

      // Append each field in the data object to FormData
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }

      if (
        individualMileStone === null &&
        ContractChangeRequest[editIndex || 0]?.files?.length > 0
      ) {
        ContractChangeRequest[editIndex || 0]?.files.forEach((file) => {
          formData.append("files", file.file);
        });
      }

      try {
        const response = await axios.post(
          "/cvault/change-request-temp-chat/",
          formData,
          {
            headers: headers,
          }
        );

        handleSendMessage();
        setLoader(false);

        setSendcomment(true);
        // MilestonechangeRequest(changeprojectid);
        MilestonechangeRequest(
          changeprojectid,
          individualMileStone !== null ? individualMileStone : null
        );
        setIndividualMileStone(null);
      } catch (error) {
        setLoader(false);

        // toast.error("Something went wrong. Please try again later");
        if (error?.response?.data?.error?.includes("already")) {
          setFileError(error?.response?.data?.error);
        } else {
          setFileError("Unable to send the message. Please try again later.");
        }
      }
    }
  };

  const MilestonechangeRequestData = selectedMileStone.map(
    (milestone, index) => ({
      milestone: milestone.id,
      milestone_name: milestone.milestone,
      description: milestone.milestone_description,
      price: milestone.milestone_amount,
      comment: newMessage,
      // files: files.map(v=>v.file),
    })
  );

  const Reuploadfeedback = async () => {
    setLoader(true);
    try {
      setLoader(true);
      const data = {
        changeRequestData:
          individualMileStone !== null
            ? changeRequestData[0]
            : changeRequestData,
        project: changeprojectid,
      };

      const mileStonePayload = {
        project: changeprojectid,
        milestone_id:
          MilestonechangeRequestData[0]?.id ||
          MilestonechangeRequestData[0]?.milestone,
        changeRequestData: MilestonechangeRequestData[0],
        files: files.map((v) => v.file),
      };

      const formData = new FormData();
      // Append each field in the data object to FormData
      // for (const key in mileStonePayload) {
      //   console.log(')))',key);

      //   if (mileStonePayload[key] !== null && mileStonePayload[key] !== undefined) {
      //     formData.append(key, mileStonePayload[key]);
      //   }
      // }

      // Append simple fields directly to FormData using a loop

      const simpleFields = ["project", "milestone_id"];
      for (let field of simpleFields) {
        formData.append(field, mileStonePayload[field]);
      }

      formData.append(
        "changeRequestData",
        JSON.stringify(mileStonePayload.changeRequestData)
      );
      setChangeContract(false);

      handleSendMessage();

      // Append the nested 'changeRequestData' fields using a loop
      // for (let key in mileStonePayload.changeRequestData) {
      //   if (mileStonePayload.changeRequestData.hasOwnProperty(key)) {
      //     formData.append(key, mileStonePayload.changeRequestData[key]);
      //   }
      // }

      // Append the files (if any) to FormData using a loop
      for (let i = 0; i < mileStonePayload.files.length; i++) {
        const file = mileStonePayload.files[i];
        // Append the actual binary file to the FormData object
        if (file instanceof File) {
          formData.append(`files`, file);
        }
      }

      // if (individualMileStone!==null&&MilestonechangeRequestData.length > 0) {
      //   // Iterate through the files and append each one to FormData
      //   MilestonechangeRequestData[0]?.files?.forEach(v => {
      //     formData.append('files', v.file);
      //   });
      // }

      let api = "";
      if (individualMileStone === null) {
        api = "/cvault/project-change-request/";
      } else {
        api = "/cvault/milestone-change-request/";
      }
      const response = await axios.post(
        api,
        individualMileStone === null ? data : formData,
        {
          headers: headers,
        }
      );
      setLoader(false);
      if (individualMileStone !== null) {
        toast.success(
          `Change request for Milestone (${
            individualMileStone?.row?.milestone_number || 1
          }) sent to Contractor`
        );
      } else {
        toast.success(`Change request(s) sent to Contractor`);
      }
      // toast.success("Change request(s) sent to Contractor for approval");
      getownerProjectlist();
      handleMilestoneModal(changeprojectid);

      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
      setMileStoneModal(false);
    } catch (error) {
      setLoader(false);
      // setChangeProjectid("");
      setLoader(false);
      console.error("Error submitting form:", error);
      if (error?.response?.data?.error?.includes("already")) {
        setFileError(error?.response?.data?.error);
      } else {
        setFileError(
          "Unable to process the change request. Please try again later"
        );
      }
    }
  };

  const MilestonechangeRequest = async (id, mile = null) => {
    setLoader(true);
    try {
      const milestoneId = {
        project_id: id,
      };
      if (mile !== null) {
        milestoneId.milestone_id = mile?.id;
        // setEditIndex(0);
      }
      // setEditIndex(null);
      const response = await axios.post(
        "/cvault/milestone-details/",
        milestoneId,
        {
          headers: headers,
        }
      );
      const pData = response?.data?.data;
      let mileStoneNumber = mile?.row?.milestone_number || 1;

      if (notification) {
        const index = pData?.findIndex(
          (item) => item.id === notification?.milestone_id
        );

        const milesId = {
          project_id: notification?.project_id,
          id: notification?.milestone_id,
        };

        const mileResponse = await axios.post(
          "/cvault/milestone-details/",
          milesId,
          {
            headers: headers,
          }
        );

        const miledetails = await axios.get(
          `/cvault/get-milestones/?project_id=${notification?.project_id}`
        );

        const milefilterData = miledetails?.data?.data.filter(
          (item) => item.id === notification?.milestone_id
        );

        const milestoneData = mileResponse?.data?.data || [];
        const mileIndex = milestoneData.findIndex(
          (item) => item.id === notification?.milestone_id
        );
        const miledata = milestoneData.filter(
          (item) => item.id === notification?.milestone_id
        );

        if (index !== -1) {
          if (notification?.project_status === "In Progress") {
            let projResponse = await axios.get("/cvault/get-project-detail/");
            let projList = projResponse?.data?.data || [];

            projList = projList.map((project, index) => ({
              ...project,
              id: index + 1,
            }));

            const projectData = projList.find(
              (item) => item.project_id === notification?.project_id
            );

            if (projectData) {
              setSelectedProject(projectData);
            }

            if (milefilterData?.[0]) {
              if (
                milefilterData[0]?.status === "Not Started" ||
                milefilterData[0]?.status === "In Progress" ||
                milefilterData[0]?.status === "CR Phase"
              ) {
                if (
                  milefilterData[0]?.status !== "In Progress" &&
                  (milefilterData[0]?.change_request_status?.status === "" ||
                    milefilterData[0]?.change_request_status?.status ===
                      "Owner Review" ||
                    milefilterData[0]?.change_request_status?.status ===
                      "Review")
                ) {
                  setMileStoneModal(true);
                } else {
                  milefilterData[0]?.status !== "In Progress" &&
                    toast.warning(`Action already taken`);
                }
              } else {
              }
            }

            if (miledata?.[0]) {
              setEditIndex(mileIndex);
              // setIndividualMileStone(miledata[0]);
              // setIndividualMileStone({ id: miledata[0]?.id, row: miledata[0] });

              handlegetchat(miledata[0], mileIndex, notification?.project_id);
              setScroll(true);
            }
          } else {
            setEditIndex(mileIndex);
            handlegetchat(miledata?.[0], mileIndex, notification?.project_id);
            setScroll(true);
          }

          if (milefilterData[0]?.milestone_number) {
            mileStoneNumber = milefilterData[0]?.milestone_number;
          }
          // handlegetchat(miledata?.[0], mileIndex, notification?.project_id);
        }
      }
      setLoader(false);
      setDisabled(response?.data?.status);
      if (mile !== null) {
        setSelectedMileStone(
          pData.map((val) => {
            return {
              ...val,
              milestone_number: mileStoneNumber,
              mileStatus: mile?.row?.status,
              files: [],
            };
          })
        );
      } else {
        setContractChangeRequest(
          pData.map((val, index) => {
            return {
              ...val,
              milestone_number: mile?.row?.milestone_number || index + 1,
              files: [],
            };
          })
        );
      }
    } catch (error) {
      setLoader(false);
      // toast.error(
      //   "Error submitting form. Uploaded Contract document doesn't have required Milestone/Pricing Information."
      // );
    }
  };

  useEffect(() => {
    const targetElement = document.getElementById("expandOfProjec");

    if (scroll && targetElement) {
      setTimeout(() => {
        targetElement.scrollIntoView({ block: "center", behavior: "smooth" });
        targetElement.style.scrollMarginTop = "100px";
      }, 100);
    }
  }, [scroll]);

  const getFinalPayment = async (row, initial = false) => {
    try {
      const pay = await axios.get(
        `/cvault/milestone-accept-pay-details/?project_id=${row?.project}&milestone_id=${row?.id}`
      );

      if (pay.data.result) {
        setFinalPayment((prev) => ({
          ...prev,
          balance: pay.data.balance,
          additional: pay.data.additional,
          reminder_message: pay.data.reminder_message,
          previous_milestone_balance_amount:
            pay.data.previous_milestone_balance_amount,
        }));
      } else {
        setFinalPayment({
          additional: null,
          balance: null,
          reminder_message: "",
          previous_milestone_balance_amount: "",
        });
      }
      if (
        initial &&
        (row?.status === "Awaiting Payment" ||
          row?.status === "Initial Payment")
      ) {
        setPaymentModal(true);
      }
    } catch (error) {
      setFinalPayment({
        additional: null,
        balance: null,
        reminder_message: "",
        previous_milestone_balance_amount: null,
      });
      if (
        initial &&
        (row?.status === "Awaiting Payment" ||
          row?.status === "Initial Payment")
      ) {
        setPaymentModal(true);
      }
    }
  };

  const paymentInitiate = async (selmile = null) => {
    individualMileStone === null ? setLoader(true) : setLoader(true);

    try {
      const individualPaymnet = individualMileStone?.row || selmile?.row;

      const item = individualMileStone?.row?.milestone_amount || {};
      const milestonePayout = individualMileStone?.row?.milestone_payout;

      const revisedAmount =
        typeof finalPaymnet?.balance || finalPaymnet?.additional === "number"
          ? finalPaymnet?.balance || finalPaymnet?.additional // Directly use number if already a number
          : parseFloat(
              (
                finalPaymnet?.balance ||
                finalPaymnet?.additional ||
                "0"
              ).replace(/[^0-9.e+-]/g, "")
            ) || 0; // Preserve scientific notation

      const price =
        typeof individualMileStone?.row?.milestone_amount === "number"
          ? individualMileStone?.row?.milestone_amount
          : parseFloat(
              (individualMileStone?.row?.milestone_amount || "0").replace(
                /[^0-9.e+-]/g,
                ""
              )
            ) || 0;

      const final =
        finalPaymnet?.balance || finalPaymnet?.additional
          ? finalPaymnet?.additional
            ? price + revisedAmount
            : price - Math.abs(revisedAmount)
          : parseFloat(
              individualPaymnet?.milestone_amount.replace(/[$,\s]/g, "")
            );

      const paymentData = changeRequestData?.[0];
      const initialPayload = {
        project_id: changeprojectid,
        amount: parseFloat(paymentData?.price.replace(/[$,\s]/g, "")),
        // milestone_ids: [],
      };

      const mileStonePayload = {
        project_id: individualPaymnet?.project || changeprojectid,
        // amount: parseFloat(
        //   individualPaymnet?.milestone_amount.replace(/[$,\s]/g, "")
        // ),
        amount: final,
        milestone_ids: [individualPaymnet?.id],
      };

      const payload =
        individualMileStone === null && selmile === null
          ? initialPayload
          : mileStonePayload;

      var payment = await axios.post("/cvault/payment-initiation/", payload, {
        headers: headers,
      });

      setPaymentModal(false);
      setChangeContract(false);
      setMileStoneModal(false);
      setLoader(false);
      setLoader(false);
      toast.success(
        individualMileStone === null && selmile === null
          ? "Payment initiated successfully for Milestone(1)"
          : !milestonePayout
          ? `Payment initiated successfully for Milestone(${
              individualPaymnet?.milestone_number || 1
            })`
          : finalPaymnet?.additional
          ? `Payment initiated successfully for Milestone(${
              individualPaymnet?.milestone_number || 1
            })`
          : `Payment initiated successfully for Milestone(${
              individualPaymnet?.milestone_number || 1
            })`
      );
      getownerProjectlist();
      setFinalPayment({
        additional: null,
        balance: null,
        reminder_message: "",
        previous_milestone_balance_amount: null,
      });

      handleMilestoneModal(changeprojectid || individualPaymnet?.project);
    } catch (error) {
      setPaymentModal(false);
      setChangeContract(false);
      setMileStoneModal(false);
      setLoader(false);
      setLoader(false);
      toast.error("Unable to initiate the process. Please try again later");
    }
  };

  const paymentCancel = async () => {
    try {
    } catch (error) {}
  };

  const handleChange = async (params) => {
    try {
      const milestonedata = await axios.get(
        `/cvault/get-milestones/?project_id=${params?.row?.project_id}`
      );
      const initialPayload = {
        project_id: milestonedata?.data?.data?.[0]?.project,
        amount: parseFloat(
          milestonedata?.data?.data?.[0]?.milestone_amount.replace(
            /[$,\s]/g,
            ""
          )
        ),
      };
      var payment = await axios.post(
        "/cvault/payment-initiation/",
        initialPayload,
        {
          headers: headers,
        }
      );
      setLoader(false);
      toast.success("Payment initiated successfully");
      getownerProjectlist();
      if (changeprojectid) {
        handleMilestoneModal(changeprojectid);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <div className="p-4">
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {(loader || isContractLoader) && (
          <div className="loader-overlay">
            {loaderMsg && (
              <span className="loader-message">
                Fetching contract details from cloud storage. Please wait...
              </span>
            )}
            <BarLoader
              color="#F5AE41"
              width={400}
              height={10}
              className="loader"
              loading={loader || isContractLoader}
            />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between mx-1 mb-3">
        <div>
          <h4 className="fw-bold">Project List - Owner View</h4>
        </div>
      </div>
      <div className="card card-cvault">
        <div className="card-body">
          <DataGrid
            rows={ownerProjectList}
            columns={columns.map((column) => ({
              ...column,
              headerClassName,
              renderHeader,
            }))}
            getRowId={(row) => row.project_id}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            hideFooterSelectedRowCount
            localeText={{ noRowsLabel: projectLoaderMsg }}
          />
        </div>
      </div>
      {selectedProject != "" ? (
        <div className="card card-cvault mt-4 p-3" id="expandOfProject">
          <div>
            <div className="d-flex justify-content-between">
              <div></div>
            </div>

            <CMilestoneList
              setSelectedProject={setSelectedProject}
              ownerlog={ownerlog}
              milestoneListdata={milestoneListdata}
              projectname={projectname}
              handleMilestoneModal={
                //   (data) => {
                //   setMilestoneModel(!milestoneModel);
                // }
                handleMilestoneModal
              }
              setChangeContract={setChangeContract}
              setChangeProjectid={setChangeProjectid}
              MilestonechangeRequest={MilestonechangeRequest}
              handlegetchat={handlegetchat}
              setIndividualMileStone={setIndividualMileStone}
              projectStatus={projectStatus}
              paymentInitiate={paymentInitiate}
              setMileStoneModal={setMileStoneModal}
              getFinalPayment={getFinalPayment}
              setProjectLevelViewModal={setProjectLevelViewModal}
              setProjectLevelContractorFiles={setProjectLevelContractorFiles}
              setMileDocs={setMileDocs}
              setDocHeader={setDocHeader}
              projectLoaderMsg={projectLoaderMsg}
              notification={notificationData}
            />
          </div>
        </div>
      ) : null}

      <Modal
        open={Changecontract}
        onClose={() => {
          setChangeContract(false);
          setChangeContract(false);
          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
          setEditIndex(null);
          setIndividualMileStone(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "100%",
            maxHeight: "100vh", // Ensure the modal does not exceed viewport height
            overflowY: "auto",
            height: "100vh",
            margin: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-1"
            >
              <div className="w-100">
                <div className="d-flex align-items-center justify-content-between">
                  <h5>{projectLevelTitle}</h5>
                  <IoIosClose
                    className="fs-1 cursor"
                    onClick={() => {
                      setChangeContract(false);
                      setContractChangeRequest([]);
                      setChatView(false);
                      setScroll(false);
                      setEditIndex(null);
                      setIndividualMileStone(null);
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col projectname mb-1">
                    {" "}
                    <span style={{ color: "black" }}>Project</span>
                    <span> : </span>{" "}
                    <span className="projectname"> {changeprojectname}</span>
                  </div>
                  {/* <div> */}
                  <div className="col">
                    <div className="d-flex justify-content-between">
                      <span
                        className={`${
                          chatview ? "projectname" : "projectname_black"
                        }`}
                        style={{
                          marginLeft: "1%",
                        }}
                      >
                        {chatview ? "Chat Room" : "Milestone(s)"}
                      </span>
                      {chatview && (
                        <div className="cr-action-buttons">
                          <button
                            className="btn cr-deny-btn"
                            onClick={() =>
                              cancelCRRequest(milestonechangeRequestchat)
                            }
                            disabled={
                              ContractChangeRequest[editIndex || 0]
                                ?.cr_notification === ""
                            }
                          >
                            <span>CR Deny</span>
                          </button>
                          <button
                            className="btn cr-accept-btn"
                            onClick={() =>
                              individualMileStoneAccept(
                                milestonechangeRequestchat
                              )
                            }
                            disabled={
                              ContractChangeRequest[editIndex || 0]
                                ?.cr_notification === ""
                            }
                          >
                            CR Accept
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              {ContractChangeRequest.length === 0 ? (
                <h5 className="text-center text-secondary">
                  All the change request(s) have been accepted by the
                  contractor.
                </h5>
              ) : (
                <div
                  className="d-flex row custom-row"
                  style={{ marginRight: "" }}
                  id="expandOfProjec"
                >
                  <div
                    className={chatview ? "col-md-6" : "col-md-6"}
                    style={{
                      height: "calc(100vh - 150px)", // Adjust for header/footer heights (header ~ 60px, footer ~ 70px)
                      overflow: "auto",
                    }}
                  >
                    {selectedPdfFile && (
                      <>
                        <iframe
                          title="PDF Viewer"
                          style={{ ...iframeStyle, height: "98%" }}
                          src={selectedPdfFile}
                        />
                      </>
                    )}
                  </div>
                  <div
                    className="col-md-6 pt-2"
                    style={{
                      borderLeft: "1px solid #ccc",
                      height: !isMobile
                        ? ContractChangeRequest[editIndex || 0]?.files
                          ? "calc(100vh - 150px)"
                          : "calc(100vh - 144px)"
                        : "", // Adjust for header/footer heights
                      overflow: "auto",
                    }}
                  >
                    {chatview && (
                      <div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <ArrowBackIcon
                              style={{ cursor: "pointer", fontSize: "20px" }}
                              onClick={() => {
                                setChatView(false);
                                setEditIndex(null);
                              }}
                            />
                            <div>
                              <span
                                className="text-dark ms-1"
                                style={{ fontWeight: 500 }}
                              >
                                {" "}
                                Milestone :{" "}
                              </span>
                              {milestonechangeRequestchat?.milestone_number ||
                                1}
                              . {milestonechangeRequestchat?.milestone}
                            </div>
                          </div>
                          <div>
                            {ContractChangeRequest[editIndex || 0]
                              ?.amount_status !== "noChange" &&
                              ContractChangeRequest[editIndex || 0]
                                ?.amount_status && (
                                <div style={{ fontSize: "14px" }}>
                                  <span style={{ fontWeight: 500 }}>
                                    Revised Amount:{" "}
                                  </span>

                                  <span className="text-primary">
                                    $
                                    {ContractChangeRequest[editIndex || 0]
                                      ?.amount_status === "Increase"
                                      ? Number(
                                          (parseFloat(
                                            (typeof ContractChangeRequest[
                                              editIndex || 0
                                            ]?.revised_amount === "number"
                                              ? ContractChangeRequest[
                                                  editIndex || 0
                                                ]?.revised_amount.toString()
                                              : ContractChangeRequest[
                                                  editIndex || 0
                                                ]?.revised_amount || "0"
                                            ).replace(/[^0-9.]/g, "")
                                          ) || 0) +
                                            (parseFloat(
                                              (typeof ContractChangeRequest[
                                                editIndex || 0
                                              ]?.milestone_amount === "number"
                                                ? ContractChangeRequest[
                                                    editIndex || 0
                                                  ]?.milestone_amount.toString()
                                                : ContractChangeRequest[
                                                    editIndex || 0
                                                  ]?.milestone_amount || "0"
                                              ).replace(/[^0-9.]/g, "")
                                            ) || 0)
                                        ).toLocaleString("en-US")
                                      : Number(
                                          (parseFloat(
                                            (typeof ContractChangeRequest[
                                              editIndex || 0
                                            ]?.milestone_amount === "number"
                                              ? ContractChangeRequest[
                                                  editIndex || 0
                                                ]?.milestone_amount.toString()
                                              : ContractChangeRequest[
                                                  editIndex || 0
                                                ]?.milestone_amount || "0"
                                            ).replace(/[^0-9.]/g, "")
                                          ) || 0) -
                                            (parseFloat(
                                              (typeof ContractChangeRequest[
                                                editIndex || 0
                                              ]?.revised_amount === "number"
                                                ? ContractChangeRequest[
                                                    editIndex || 0
                                                  ]?.revised_amount.toString()
                                                : ContractChangeRequest[
                                                    editIndex || 0
                                                  ]?.revised_amount || "0"
                                              ).replace(/[^0-9.]/g, "")
                                            ) || 0)
                                        ).toLocaleString("en-US")}
                                  </span>
                                </div>
                              )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div />
                        </div>

                        <div
                          style={{
                            fontSize: "13px",
                            paddingLeft: "20px",
                            borderBottom: "1px solid lightgray",
                            display: "-webkit-box",
                            WebkitLineClamp: 3, // Limit to 2 lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                          }}
                        >
                          {milestonechangeRequestchat?.milestone_description}
                        </div>
                        {/* </Tooltip> */}
                      </div>
                    )}
                    {chatview && (
                      <div className="w-100">
                        <div
                          style={{
                            // border: "1px solid #ccc",
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              height: isMobile
                                ? "250px"
                                : ContractChangeRequest[editIndex || 0]?.files
                                ? "calc(100vh - 390px)"
                                : "calc(100vh - 380px)",
                              overflow: "auto",
                            }}
                          >
                            {Nochat && (
                              <div className="d-flex justify-content-center mt-4">
                                <span className="text-secondary text-center fw-normal">
                                  No Change Request History available
                                </span>
                              </div>
                            )}
                            {messages.map((message, index) => (
                              <div key={message}>
                                <div
                                  key={index}
                                  className={`message ${
                                    message?.user === "Owner"
                                      ? "user-message"
                                      : "ai-message"
                                  }`}
                                  style={{
                                    fontSize: "14px",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {typeof message?.chat === "string"
                                    ? message.chat
                                        .split("\n")
                                        .map((line, index) => (
                                          <React.Fragment key={index}>
                                            {line}
                                            <br />
                                          </React.Fragment>
                                        ))
                                    : typeof message?.chat === "object"
                                    ? Object.entries(message.chat)
                                        .filter(
                                          ([_, value]) =>
                                            value !== 0 &&
                                            value !== null &&
                                            value !== ""
                                        ) // Filter out unwanted values
                                        .map(([key, value]) => (
                                          <div key={key}>
                                            <span style={{ fontWeight: 500 }}>
                                              {key}
                                            </span>{" "}
                                            : {value}
                                          </div>
                                        ))
                                    : message?.chat}
                                </div>
                                <div>{viewChatFiles(message, index)}</div>
                              </div>
                            ))}
                          </div>
                          <div
                            style={{
                              marginTop: "10px",
                              width: "100%",
                              // height: "100px",
                              height:
                                ContractChangeRequest[editIndex || 0]?.files
                                  ?.length > 0
                                  ? "90px"
                                  : "70px",
                            }}
                            className="me-4"
                          >
                            <div
                              style={{
                                width: "100%",
                                border: "1px solid lightgray",
                                borderBottom: "0px",
                                borderRadius: "5px 5px 0px 0px",
                                marginTop: "5px",
                              }}
                            >
                              {ContractChangeRequest[editIndex || 0]?.files
                                ?.length !== 0 && (
                                <div
                                  className="mt-1 -ml-1.5 d-flex flex-nowrap gap-2 overflow-x-auto p-1.5"
                                  style={{
                                    width: "95%",
                                    margin: "auto",
                                    overflowX: "auto",
                                  }}
                                >
                                  {ContractChangeRequest[
                                    editIndex || 0
                                  ]?.files?.map((item, index) => (
                                    <div
                                      key={index}
                                      className="preview-item group relative inline-block text-sm text-token-text-primary"
                                      style={{
                                        width: "220px",
                                        minWidth: "220px",
                                        marginLeft: "5px",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl">
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            border: "1px solid lightgray",
                                            borderRadius: "4px",
                                            alignItems: "center", // Ensure alignment
                                            padding: "5px",
                                            cursor: "pointer", // Make it look clickable
                                          }}
                                          className="d-flex flex-row align-items-center gap-2"
                                          onClick={() => {
                                            // Define a common function to open the file
                                            if (item.type !== "others") {
                                              setContractDocuments(true);
                                              setSelectedContractDoc(
                                                URL.createObjectURL(item.blob)
                                              );
                                            } else {
                                              const link =
                                                document.createElement("a");
                                              link.href = item.blob;
                                              link.download = item.name; // Set file name for download
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                            }
                                            // const newTab = window.open();
                                            const newTab = false;
                                            if (newTab) {
                                              if (
                                                item?.type?.includes("image")
                                              ) {
                                                newTab.document.write(
                                                  `<img src="${URL.createObjectURL(
                                                    item.blob
                                                  )}" style="height:100%; display:flex; margin:auto" />`
                                                );
                                                newTab.document.title =
                                                  "Image Preview";
                                              } else if (
                                                item?.type === "video"
                                              ) {
                                                newTab.document.body.innerHTML = `<video controls autoplay style="width:100%; height:100vh;"><source src="${URL.createObjectURL(
                                                  item.blob
                                                )}" type="${
                                                  item.file.type
                                                }"></video>`;
                                                newTab.document.title =
                                                  "Video Preview";
                                              } else if (
                                                item?.type === "text"
                                              ) {
                                                const reader = new FileReader();
                                                reader.readAsText(item.blob);
                                                reader.onload = () => {
                                                  newTab.document.body.innerHTML = `<pre style="white-space: pre-wrap; word-wrap: break-word; font-family: monospace; padding: 20px;">${reader.result}</pre>`;
                                                  newTab.document.title =
                                                    "Text File Preview";
                                                };
                                              } else if (
                                                item.type.includes("pdf")
                                              ) {
                                                newTab.document.body.innerHTML = `<iframe src="${URL.createObjectURL(
                                                  item.blob
                                                )}" style="width:100%; height:100vh; border:none;"></iframe>`;
                                                newTab.document.title =
                                                  "PDF Preview";
                                              }
                                            }
                                          }}
                                        >
                                          {/* Icon */}
                                          <TextSnippetIcon
                                            style={{
                                              width: "27px",
                                              height: "27px",
                                              color: "#F5AE41",
                                              opacity: "0.9",
                                            }}
                                          />

                                          <div
                                            style={{
                                              fontSize: "13px",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            {(() => {
                                              const fileName = item?.name
                                                .split("/")
                                                .pop(); // Extract filename from path
                                              if (fileName.length > 15) {
                                                return (
                                                  fileName.slice(0, 20) +
                                                  "..." +
                                                  fileName.slice(-4)
                                                );
                                              }
                                              return fileName;
                                            })()}
                                          </div>
                                        </div>

                                        {/* Delete Button */}
                                        <button
                                          className="delete-btn"
                                          onClick={(e) => {
                                            e.stopPropagation(); // Prevent triggering the file open on delete click
                                            setFileError("");
                                            handleDeleteProjectLevel(
                                              index,
                                              editIndex || 0
                                            );
                                          }}
                                        >
                                          X
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                            <TextField
                              placeholder="Type your message here..."
                              rows={2.3}
                              multiline
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  paddingRight: "0px",
                                  border: "none", // Remove border for the input container
                                },
                                "& .MuiInputBase-input": {
                                  padding: "0px 10px",
                                  backgroundColor: "#FFF",
                                  borderRadius: "0px",
                                  border: "none", // Remove border for the input itself
                                  fontSize: "12px",
                                  width: "100%",
                                  borderBottomLeftRadius: "4px", // Radius for bottom-left corner
                                  borderBottomRightRadius: "4px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none", // Remove border for the input container
                                  borderLeft: "1px solid lightgray",
                                  borderRight: "1px solid lightgray",
                                  borderRadius: "0px",
                                },
                                // Focus state
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none", // Keep no border even when focused
                                    borderLeft: "1px solid lightgray",
                                    borderRight: "1px solid lightgray",
                                    borderRadius: "0px",
                                  },
                                // Hover state - remove border color
                                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderLeft: "1px solid lightgray", // Keep the same border when hovered
                                    borderRight: "1px solid lightgray", // Keep the same border when hovered
                                    borderRadius: "0px",
                                  },
                              }}
                              size="small"
                              id="chatInput"
                              type="text"
                              fullWidth
                              className="chatinput"
                              value={newMessage}
                              disabled={loader || sendcomment !== "enable"}
                              onChange={(e) => {
                                const trimmedValue = e.target.value.trim();
                                if (
                                  trimmedValue ||
                                  e.target.value.length === 0
                                ) {
                                  setNewMessage(e.target.value);
                                }
                              }}
                              // onKeyDown={(e) => {
                              //   if (
                              //     e.key === "Enter" &&
                              //     sendcomment === "enable"
                              //   ) {
                              //     // handleSendMessage();
                              //     sendchat();
                              //   }
                              // }}
                              InputProps={{
                                endAdornment: (
                                  <></>
                                  // <InputAdornment position="end">
                                  // <IconButton
                                  //   onClick={() => {
                                  //     handleSendMessage();
                                  //     sendchat();
                                  //   }}
                                  //   className="btn chatbtn mt-1"
                                  //   style={{
                                  //     backgroundColor: "#e9ecef",
                                  //     borderLeft: "0px",
                                  //     right: "7px",
                                  //     borderRadius: "50%",
                                  //   }}
                                  //   disabled={sendcomment !== "enable"}
                                  // >
                                  //   <SendIcon
                                  //     style={{
                                  //       color:
                                  //         sendcomment !== "enable"
                                  //           ? "gray"
                                  //           : "#013e6a",
                                  //       width: ".8em",
                                  //       height: ".8em",
                                  //     }}
                                  //   />
                                  // </IconButton>
                                  // </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{
                              border: "1px solid lightgray",
                              borderTop: "0px",
                              // borderRadius:files.length===0?"4px":'0px',
                              borderBottomLeftRadius: "4px", // Radius for bottom-left corner
                              borderBottomRightRadius: "4px", // Radius for bottom-right corner
                              border: "1px solid lightgray",
                            }}
                          >
                            <div
                              className="d-flex align-items-center"
                              style={{ zIndex: 1 }}
                            >
                              <Tooltip placement="top" title="Upload a file">
                                <IconButton
                                  style={{
                                    border: "1px solid lightgray",
                                    margin: "5px",
                                    // padding:'2px'
                                  }}
                                  component="label"
                                >
                                  <AttachFileIcon
                                    style={{ fontSize: "16px" }}
                                  />
                                  <input
                                    type="file"
                                    accept=".pdf, .txt, image/*, video/*"
                                    hidden
                                    multiple
                                    onChange={(e) => {
                                      setFileError("");
                                      handleFileUploadChangeRequestProjectLevel(
                                        e,
                                        editIndex || 0
                                      );
                                    }}
                                    disabled={sendcomment !== "enable"}
                                  />
                                </IconButton>
                              </Tooltip>
                              {fileError !== "" && (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  {fileError}
                                </span>
                              )}
                            </div>

                            <Tooltip placement="top" title="">
                              <Button
                                onClick={() => {
                                  // handleSendMessage();
                                  sendchat();
                                }}
                                className="btn chatbtn mt-1"
                                style={{
                                  backgroundColor: "#e9ecef",
                                  borderLeft: "0px",
                                  right: "7px",
                                  padding: "5px 7px",
                                  // borderRadius: "50%",
                                  textTransform: "none",
                                  color:
                                    sendcomment !== "enable" ||
                                    newMessage.trim() === ""
                                      ? "gray"
                                      : "#013e6a",
                                }}
                                disabled={
                                  sendcomment !== "enable" ||
                                  newMessage.trim() === ""
                                }
                                size="small"
                              >
                                Save Change
                              </Button>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    )}
                    {!chatview && (
                      <>
                        {ContractChangeRequest.map((milestone, index) => (
                          <div
                            key={index}
                            className="row custom-row pt-2"
                            style={{
                              background: "#f0f0f0",
                              borderRadius: "5px",
                              marginBottom: "10px",
                              marginLeft: "4px",
                            }}
                          >
                            <div className={chatview ? "col-md-12" : ""}>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <div
                                    className="d-flex align-items-center"
                                    style={{ minWidth: "250px" }}
                                  >
                                    <label className="d-flex align-items-center milestonechangeRequest">
                                      {index + 1 + ". "}
                                    </label>

                                    <span
                                      style={{
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        display: "inline-block",
                                        // minWidth:'200px',
                                        // maxWidth: "200px", // Adjust based on available space
                                        marginLeft: "7px",
                                      }}
                                      className="text-primary"
                                    >
                                      {milestone?.milestone}
                                    </span>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-end">
                                  <span
                                    className="text-danger me-3"
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {milestone?.temp_notification}
                                  </span>
                                  <div className="d-flex">
                                    <p
                                      style={{
                                        // marginRight:
                                        //   milestone?.cr_notification === "CR raised"
                                        //     ? "5px"
                                        //     : "",
                                        // marginBottom: "5px",
                                        margin: "0px",
                                        marginBottom: "0px",
                                        marginLeft: "0px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        Amount:{" "}
                                      </span>
                                      <span className="text-primary me-3">
                                        $
                                        {milestone?.milestone_amount
                                          .replace(".00", "")
                                          .replace("$", "")}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="text-end">
                                    <Tooltip title={"Raise a Change Request"}>
                                      <FontAwesomeIcon
                                        icon={faEdit}
                                        className="text-success cursor fs-5"
                                        onClick={() => {
                                          handlegetchat(milestone);
                                          setScroll(true);
                                          setEditIndex(index);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                  {milestone?.cr_notification === "CR raised" &&
                                  milestone?.temp_notification !==
                                    "CR saved" ? (
                                    <div className="ms-3">
                                      <img
                                        src={BellIcon}
                                        alt="bellicon"
                                        style={{
                                          width: "1.4rem",
                                          height: "1.4rem",
                                          objectFit: "cover",
                                          cursor: "pointer",
                                          marginBottom: "2px",
                                        }}
                                        className="shake-top"
                                        onClick={() => {
                                          handlegetchat(milestone, index);
                                          setScroll(true);
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="ms-2"
                                      style={{ width: "23px" }}
                                    ></div>
                                  )}
                                </div>
                              </div>

                              <div>
                                <div className="d-flex align-items-center justify-content-between pt-1 pb-1">
                                  <label
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    Milestone Description
                                  </label>
                                  {milestone?.original_amount !== null &&
                                    milestone?.original_amount !== "" && (
                                      <div
                                        style={{
                                          marginRight: "32px",
                                          fontSize: "14px",
                                        }}
                                      >
                                        <span style={{ fontWeight: 500 }}>
                                          Original Amount:{" "}
                                        </span>
                                        <span className="text-primary">
                                          {milestone.original_amount.includes(
                                            "$"
                                          )
                                            ? milestone.original_amount.replace(
                                                ".00",
                                                ""
                                              )
                                            : `${
                                                "$" +
                                                milestone.original_amount.replace(
                                                  ".00",
                                                  ""
                                                )
                                              }`}
                                        </span>
                                      </div>
                                    )}
                                </div>
                                {milestone?.milestone_description !== "" && (
                                  <div
                                    style={{
                                      // marginTop: "10px",
                                      overflowY: "auto",
                                      overflowX: "hidden",
                                      maxHeight: "200px",
                                      height: "auto",
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      // fontFamily: "sans-serif",
                                      background: editIndex === index ? "" : "",
                                      // padding: "10px",
                                      border:
                                        editIndex === index
                                          ? "1px solid #0d6efd"
                                          : "1px solid lightgray",
                                      border: "none",
                                      paddingBottom: "10px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    <div>
                                      {milestone?.milestone_description}
                                    </div>
                                    <div>
                                      {milestone?.change_request?.length > 0 &&
                                        milestone?.change_request.map(
                                          (request, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                marginTop: "5px",
                                              }}
                                            >
                                              <strong>
                                                {
                                                  request?.change_request_heading
                                                }
                                              </strong>{" "}
                                              <div>
                                                {"Initiated Date: " +
                                                  request.initiate_date}
                                              </div>
                                              <div>
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_name
                                                }{" "}
                                                (
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_role
                                                }
                                                ) initiated a change request
                                              </div>
                                              {request?.change_request_description?.map(
                                                (msg, msgIndex) => (
                                                  <div>
                                                    <div key={msgIndex}>
                                                      <span>
                                                        {msg?.user_name} (
                                                        {msg?.user_role}):{" "}
                                                        {msg?.message}
                                                      </span>

                                                      {msg?.files_path?.length >
                                                        0 && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <Tooltip
                                                            title={
                                                              !expanded[
                                                                msgIndex
                                                              ]
                                                                ? "Click to expand files"
                                                                : "Click to collpase files"
                                                            }
                                                            placement="right"
                                                          >
                                                            <div
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              className="d-flex align-items-center"
                                                              onClick={() =>
                                                                toggleExpand(
                                                                  msgIndex
                                                                )
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  transition:
                                                                    "transform 0.3s ease",

                                                                  fontSize:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  version="1.1"
                                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                  viewBox="0 0 512 512"
                                                                  width={15}
                                                                  height={15}
                                                                  style={{
                                                                    marginBottom:
                                                                      "4px",
                                                                    enableBackground:
                                                                      "new 0 0 512 512",
                                                                  }}
                                                                  xmlSpace="preserve"
                                                                >
                                                                  <g>
                                                                    <path
                                                                      d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                      fill={
                                                                        "#000"
                                                                      }
                                                                    />
                                                                  </g>
                                                                </svg>
                                                                <span
                                                                  className="text-primary"
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    marginLeft:
                                                                      "5px",
                                                                  }}
                                                                >
                                                                  {msg
                                                                    ?.files_path
                                                                    ?.length ===
                                                                  1
                                                                    ? "1 document"
                                                                    : `${msg?.files_path?.length} documents`}
                                                                </span>
                                                              </span>
                                                            </div>
                                                          </Tooltip>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <Collapse
                                                      in={expanded[msgIndex]}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <ol
                                                        style={{
                                                          marginBottom: "0rem",
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        {msg?.files_path?.map(
                                                          (file, fileIndex) => (
                                                            <li key={fileIndex}>
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                                onClick={() => {
                                                                  viewFiles(
                                                                    file
                                                                  );
                                                                }}
                                                              >
                                                                <i>
                                                                  {file
                                                                    .split("/")
                                                                    .pop()}
                                                                </i>
                                                              </span>
                                                            </li>
                                                          )
                                                        )}
                                                      </ol>
                                                    </Collapse>
                                                  </div>
                                                )
                                              )}
                                              {request?.revised_amount !==
                                                null && (
                                                <div>
                                                  Amount:{" "}
                                                  {request?.revised_amount
                                                    .replace("$$", "$")
                                                    .replace(".00", "")}
                                                </div>
                                              )}
                                              <div>
                                                {request?.accepted_date
                                                  ? "Accepted date: "
                                                  : "Denied date: "}
                                                {request?.accepted_date ||
                                                  request?.denied_date}
                                              </div>
                                              <div>
                                                {request?.accepted_denied_by}{" "}
                                                <strong>
                                                  {request?.accepted_date
                                                    ? "accepted"
                                                    : "denied"}
                                                </strong>{" "}
                                                the change request
                                              </div>
                                            </div>
                                          )
                                        )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  <div
                    style={{
                      background: "white",
                      position: "sticky",
                      padding: "10px 10px 10px 10px",
                      bottom: 0,
                      zIndex: 2,
                      borderTop: "1px solid lightgray",
                    }}
                  >
                    <div className="mt-2 d-flex justify-content-end">
                      <Tooltip
                        title={
                          ContractChangeRequest.some(
                            (milestone) =>
                              milestone.temp_notification === "CR saved"
                          ) &&
                          ContractChangeRequest.every(
                            (milestone) =>
                              milestone.temp_notification === "CR saved" ||
                              (milestone.cr_notification === "CR raised" &&
                                milestone.temp_notification === "CR saved") ||
                              (milestone.temp_notification === "" &&
                                milestone.cr_notification === "")
                          )
                            ? ""
                            : ContractChangeRequest.every(
                                (milestone) =>
                                  milestone.temp_notification === "" &&
                                  milestone.cr_notification === ""
                              )
                            ? "Initiate a change request"
                            : "Review and respond to all change requests raised by the Contractor"
                        }
                      >
                        <div>
                          <button
                            className="btn detail-btn me-2 bg-danger text-white"
                            onClick={() => {
                              Reuploadfeedback();
                            }}
                            disabled={
                              !(
                                ContractChangeRequest.some(
                                  (milestone) =>
                                    milestone.temp_notification === "CR saved"
                                ) &&
                                ContractChangeRequest.every(
                                  (milestone) =>
                                    milestone.temp_notification ===
                                      "CR saved" ||
                                    (milestone.cr_notification ===
                                      "CR raised" &&
                                      milestone.temp_notification ===
                                        "CR saved") ||
                                    (milestone.temp_notification === "" &&
                                      milestone.cr_notification === "")
                                )
                              )
                              // false
                            }
                          >
                            Submit Change Request(s) to Contractor
                          </button>
                        </div>
                      </Tooltip>
                      <Tooltip title={""}>
                        <div>
                          <button
                            style={{ fontSize: "14px" }}
                            className="btn btn-cvault"
                            onClick={() => {
                              // Acceptproject();
                              setPaymentModal(true);
                              setChangeContract(false);
                              setMileStoneModal(false);
                            }}
                            disabled={
                              !ContractChangeRequest.every(
                                (milestone) =>
                                  milestone.temp_notification === "" &&
                                  milestone.cr_notification === ""
                              )
                              // false
                            }
                          >
                            Accept Contract
                          </button>
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      {/*Milestone Modal */}

      <Modal
        open={mileStoneModal}
        onClose={() => {
          setMileStoneModal(false);
          setTextAreaValues([]);
          setFinalPayment({
            additional: null,
            balance: null,
            reminder_message: "",
            previous_milestone_balance_amount: null,
          });
          setEnableTextarea(Array(selectedMileStone.length).fill(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modelStyle}>
          <div>
            {/* <div> */}{" "}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex align-items-center justify-content-between ps-4 pe-2 pt-2"
            >
              <div className="row" style={{ width: "100%" }}>
                <h5 className="col">Milestone Change Request</h5>
                <h5 className="projectname col" style={{ marginLeft: "1%" }}>
                  Chat Room
                </h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setMileStoneModal(false);
                  setSelectedMileStone([]);
                  setChatView(false);
                  setScroll(false);
                  setEditIndex(null);
                  setFinalPayment({
                    additional: null,
                    balance: null,
                    reminder_message: "",
                    previous_milestone_balance_amount: null,
                  });
                }}
              />
            </div>
            <div style={{ padding: "0px 16px" }}>
              {selectedMileStone.length === 0 ? (
                <>
                  <h5 className="text-center text-secondary">
                    All the change request(s) have been accepted by the
                    contractor.{" "}
                  </h5>
                </>
              ) : (
                <div
                  className="d-flex  row custom-row "
                  id="expandOfProjec"
                  style={{ width: "100%", margin: "auto" }}
                >
                  <div
                    className={chatview ? "col-md-6" : "col-md-12"}
                    style={{
                      height: "calc(-150px + 100vh)",
                      overflow: "auto",
                      background: "bisque",
                    }}
                  >
                    {selectedMileStone.map((milestone, index) => (
                      <div key={index} className="row  custom-row pt-2">
                        <div className={chatview ? "col-md-12" : ""}>
                          <div className="">
                            <div className="d-flex flex-column">
                              <div className="d-flex align-items-center">
                                <label
                                  className="milestonechangeRequest me-2"
                                  style={{ minWidth: "150px" }}
                                >
                                  Project
                                </label>
                                <span>:</span>
                                <span className="text-primary ms-2">
                                  {changeprojectname}
                                </span>
                              </div>
                              <div className="d-flex align-items-center">
                                <label
                                  className="milestonechangeRequest me-2"
                                  style={{ minWidth: "150px" }}
                                >
                                  Milestone
                                </label>
                                <span>:</span>
                                <span className="text-primary ms-2">
                                  {milestone?.milestone_number
                                    ? `${milestone?.milestone_number}. ${
                                        milestone?.milestone || ""
                                      }`
                                    : milestone?.milestone || ""}
                                </span>
                              </div>{" "}
                              <div className="d-flex align-items-center">
                                <label
                                  className="milestonechangeRequest me-2"
                                  style={{ minWidth: "150px" }}
                                >
                                  Amount
                                </label>
                                <span>:</span>
                                <span className="text-primary ms-2">
                                  $
                                  {milestone?.milestone_amount
                                    .replace(".00", "")
                                    .replace("$", "")}
                                </span>
                              </div>
                              {milestone?.original_amount !== null &&
                                milestone?.original_amount !== "" && (
                                  <div className="d-flex align-items-center">
                                    <label
                                      className="milestonechangeRequest me-2"
                                      style={{ minWidth: "150px" }}
                                    >
                                      Original Amount
                                    </label>
                                    <span>:</span>
                                    <span className="text-primary ms-2">
                                      {milestone.original_amount.includes("$")
                                        ? milestone.original_amount.replace(
                                            ".00",
                                            ""
                                          )
                                        : `${
                                            "$" +
                                            milestone.original_amount.replace(
                                              ".00",
                                              ""
                                            )
                                          }`}
                                    </span>
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="d-flex justify-content-end"></div>
                          <div className="d-grid">
                            <label className="milestonechangeRequest">
                              Milestone Description
                            </label>
                            <div
                              style={{
                                marginTop: "10px",
                                overflowX: "hidden",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}
                            >
                              <div>{milestone.milestone_description}</div>
                              <div>
                                {milestone?.change_request?.length > 0 &&
                                  milestone?.change_request.map(
                                    (request, index) => (
                                      <div
                                        key={index}
                                        style={{
                                          marginTop: "5px",
                                        }}
                                      >
                                        <strong>
                                          {request?.change_request_heading}
                                          {":"}
                                        </strong>

                                        <div>
                                          {"Initiated Date: " +
                                            request.initiate_date}
                                        </div>
                                        <div>
                                          {
                                            request
                                              ?.change_request_description?.[0]
                                              ?.user_name
                                          }{" "}
                                          (
                                          {
                                            request
                                              ?.change_request_description?.[0]
                                              ?.user_role
                                          }
                                          ) initiated a change request
                                        </div>

                                        {request?.change_request_description?.map(
                                          (msg, msgIndex) => (
                                            <div>
                                              <div key={msgIndex}>
                                                <span>
                                                  {msg?.user_name} (
                                                  {msg?.user_role}):{" "}
                                                  {msg?.message}
                                                </span>

                                                {msg?.files_path?.length >
                                                  0 && (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <Tooltip
                                                      title={
                                                        !expanded[msgIndex]
                                                          ? "Click to expand files"
                                                          : "Click to collpase files"
                                                      }
                                                      placement="right"
                                                    >
                                                      <div
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        className="d-flex align-items-center"
                                                        onClick={() =>
                                                          toggleExpand(msgIndex)
                                                        }
                                                      >
                                                        <span
                                                          style={{
                                                            transition:
                                                              "transform 0.3s ease",

                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            version="1.1"
                                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                                            viewBox="0 0 512 512"
                                                            width={15}
                                                            height={15}
                                                            style={{
                                                              marginBottom:
                                                                "4px",
                                                              enableBackground:
                                                                "new 0 0 512 512",
                                                            }}
                                                            xmlSpace="preserve"
                                                          >
                                                            <g>
                                                              <path
                                                                d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                fill={"#000"}
                                                              />
                                                            </g>
                                                          </svg>
                                                          <span
                                                            className="text-primary"
                                                            style={{
                                                              fontSize: "13px",
                                                              marginLeft: "5px",
                                                            }}
                                                          >
                                                            {msg?.files_path
                                                              ?.length === 1
                                                              ? "1 document"
                                                              : `${msg?.files_path?.length} documents`}
                                                          </span>
                                                        </span>
                                                      </div>
                                                    </Tooltip>
                                                  </div>
                                                )}
                                              </div>
                                              <Collapse
                                                in={expanded[msgIndex]}
                                                style={{ marginLeft: "5px" }}
                                              >
                                                <ol
                                                  style={{
                                                    marginBottom: "0rem",
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  {msg?.files_path?.map(
                                                    (file, fileIndex) => (
                                                      <li key={fileIndex}>
                                                        <span
                                                          style={{
                                                            cursor: "pointer",
                                                            textDecoration:
                                                              "underline",
                                                          }}
                                                          onClick={() => {
                                                            viewFiles(file);
                                                          }}
                                                        >
                                                          <i>
                                                            {file
                                                              .split("/")
                                                              .pop()}
                                                          </i>
                                                        </span>
                                                      </li>
                                                    )
                                                  )}
                                                </ol>
                                              </Collapse>
                                            </div>
                                          )
                                        )}

                                        {request?.revised_amount !== null && (
                                          <div>
                                            Amount:{" "}
                                            {request?.revised_amount
                                              .replace("$$", "$")
                                              .replace(".00", "")}
                                          </div>
                                        )}
                                        <div>
                                          {request?.accepted_date
                                            ? "Accepted date: "
                                            : "Denied date: "}
                                          {request?.accepted_date ||
                                            request?.denied_date}
                                        </div>
                                        <div>
                                          {request?.accepted_denied_by}{" "}
                                          <strong>
                                            {request?.accepted_date
                                              ? "accepted"
                                              : "denied"}
                                          </strong>{" "}
                                          the change request
                                        </div>
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div
                    className="col-md-6  pt-2"
                    style={{
                      borderLeft: "1px solid #ccc",
                      paddingRight: "0px",
                    }}
                  >
                    {chatview && (
                      <div className="d-flex align-items-center justify-content-between">
                        <div />

                        {selectedMileStone[0]?.amount_status !== "noChange" &&
                          selectedMileStone[0]?.amount_status && (
                            <div className="me-3">
                              Revised Amount:{" "}
                              <span className="text-primary">
                                $
                                {selectedMileStone[0]?.amount_status ===
                                "Increase"
                                  ? Number(
                                      (parseFloat(
                                        (typeof selectedMileStone[0]
                                          ?.revised_amount === "number"
                                          ? selectedMileStone[0]?.revised_amount.toString()
                                          : selectedMileStone[0]
                                              ?.revised_amount || "0"
                                        ).replace(/[^0-9.]/g, "")
                                      ) || 0) +
                                        (parseFloat(
                                          (typeof selectedMileStone[0]
                                            ?.milestone_amount === "number"
                                            ? selectedMileStone[0]?.milestone_amount.toString()
                                            : selectedMileStone[0]
                                                ?.milestone_amount || "0"
                                          ).replace(/[^0-9.]/g, "")
                                        ) || 0)
                                    ).toLocaleString("en-US")
                                  : Number(
                                      (parseFloat(
                                        (typeof selectedMileStone[0]
                                          ?.milestone_amount === "number"
                                          ? selectedMileStone[0]?.milestone_amount.toString()
                                          : selectedMileStone[0]
                                              ?.milestone_amount || "0"
                                        ).replace(/[^0-9.]/g, "")
                                      ) || 0) -
                                        (parseFloat(
                                          (typeof selectedMileStone[0]
                                            ?.revised_amount === "number"
                                            ? selectedMileStone[0]?.revised_amount.toString()
                                            : selectedMileStone[0]
                                                ?.revised_amount || "0"
                                          ).replace(/[^0-9.]/g, "")
                                        ) || 0)
                                    ).toLocaleString("en-US")}
                              </span>
                            </div>
                          )}
                      </div>
                    )}
                    {chatview && (
                      <>
                        <div className="w-100">
                          <div
                            style={{
                              padding: "10px",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                height: "calc(-380px + 100vh)",
                                overflowY: "scroll",
                              }}
                            >
                              {Nochat && (
                                <div className="d-flex justify-content-center mt-4">
                                  <span className="text-secondary text-center fw-normal">
                                    No Change Request History available
                                  </span>
                                </div>
                              )}
                              {messages.map((message, index) => (
                                <>
                                  <div
                                    key={index}
                                    style={{
                                      fontSize: "14px",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    <div>
                                      <div
                                        className={`message ${
                                          message?.user == "Owner"
                                            ? "user-message"
                                            : "ai-message"
                                        }`}
                                      >
                                        {typeof message?.chat === "string"
                                          ? message.chat
                                              .split("\n")
                                              .map((line, index) => (
                                                <React.Fragment key={index}>
                                                  {line}
                                                  <br />
                                                </React.Fragment>
                                              ))
                                          : typeof message?.chat === "object"
                                          ? Object.entries(message.chat)
                                              .filter(
                                                ([_, value]) =>
                                                  value !== 0 &&
                                                  value !== null &&
                                                  value !== ""
                                              ) // Filter out unwanted values
                                              .map(([key, value]) => (
                                                <div key={key}>
                                                  <span
                                                    style={{ fontWeight: 500 }}
                                                  >
                                                    {key}
                                                  </span>{" "}
                                                  : {value}
                                                </div>
                                              ))
                                          : message?.chat}
                                      </div>
                                    </div>

                                    {viewChatFiles(message, index)}
                                  </div>
                                </>
                              ))}
                            </div>
                            <div
                              style={{
                                marginTop: "10px",
                                width: "100%",
                                height: files?.length > 0 ? "100px" : "60px",
                              }}
                              className=" me-4"
                            >
                              <div
                                style={{
                                  width: "100%",
                                  border: "1px solid lightgray",
                                  borderBottom: "0px",
                                  borderRadius: "5px 5px 0px 0px",
                                  marginTop: "5px",
                                }}
                              >
                                {files.length !== 0 && (
                                  <div
                                    className="mt-1 -ml-1.5 d-flex flex-nowrap gap-2 overflow-x-auto p-1.5 sccc"
                                    style={{
                                      width: "95%",
                                      margin: "auto",
                                      overflowX: "auto",
                                    }}
                                  >
                                    {files?.map((item, index) => (
                                      <div
                                        key={index}
                                        className="preview-item group relative inline-block text-sm text-token-text-primary"
                                        style={{
                                          width: "220px",
                                          minWidth: "220px",
                                          marginLeft: "5px",
                                          marginBottom: "5px",
                                          whiteSpace: "nowrap",
                                          // overflow: 'hidden',
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl">
                                          <div
                                            style={{
                                              width: "100%",
                                              display: "flex",
                                              border: "1px solid lightgray",
                                              borderRadius: "4px",
                                              alignItems: "center", // Ensure alignment
                                              padding: "5px",
                                              cursor: "pointer", // Make it look clickable
                                            }}
                                            className="d-flex flex-row align-items-center gap-2"
                                            onClick={() => {
                                              // Define a common function to open the file

                                              if (item.type !== "others") {
                                                setContractDocuments(true);
                                                setSelectedContractDoc(
                                                  URL.createObjectURL(item.blob)
                                                );
                                              } else {
                                                const link =
                                                  document.createElement("a");
                                                link.href = item.blob;
                                                link.download = item.name; // Set file name for download
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                              }
                                              // const newTab = window.open();
                                              const newTab = false;
                                              if (newTab) {
                                                if (
                                                  item?.type?.includes("image")
                                                ) {
                                                  newTab.document.write(
                                                    `<img src="${URL.createObjectURL(
                                                      item.blob
                                                    )}" style="height:100%; display:flex; margin:auto" />`
                                                  );
                                                  newTab.document.title =
                                                    "Image Preview";
                                                } else if (
                                                  item?.type === "video"
                                                ) {
                                                  newTab.document.body.innerHTML = `<video controls autoplay style="width:100%; height:100vh;"><source src="${URL.createObjectURL(
                                                    item.blob
                                                  )}" type="${
                                                    item.file.type
                                                  }"></video>`;
                                                  newTab.document.title =
                                                    "Video Preview";
                                                } else if (
                                                  item?.type === "text"
                                                ) {
                                                  const reader =
                                                    new FileReader();
                                                  reader.readAsText(item.blob);
                                                  reader.onload = () => {
                                                    newTab.document.body.innerHTML = `<pre style="white-space: pre-wrap; word-wrap: break-word; font-family: monospace; padding: 20px;">${reader.result}</pre>`;
                                                    newTab.document.title =
                                                      "Text File Preview";
                                                  };
                                                } else if (
                                                  item.type.includes("pdf")
                                                ) {
                                                  newTab.document.body.innerHTML = `<iframe src="${URL.createObjectURL(
                                                    item.blob
                                                  )}" style="width:100%; height:100vh; border:none;"></iframe>`;
                                                  newTab.document.title =
                                                    "PDF Preview";
                                                }
                                              }
                                            }}
                                          >
                                            {/* Icon */}
                                            <TextSnippetIcon
                                              style={{
                                                width: "35px",
                                                height: "35px",
                                                color: "#F5AE41",
                                                opacity: "0.9",
                                              }}
                                            />

                                            {/* File Name */}
                                            <div
                                              style={{
                                                fontSize: "13px",
                                                // marginLeft: "5px",
                                              }}
                                            >
                                              {(() => {
                                                const fileName = item?.name
                                                  .split("/")
                                                  .pop(); // Extract filename from path
                                                if (fileName.length > 15) {
                                                  return (
                                                    fileName.slice(0, 20) +
                                                    "..." +
                                                    fileName.slice(-4)
                                                  );
                                                }
                                                return fileName;
                                              })()}
                                            </div>
                                          </div>

                                          {/* Delete Button */}
                                          <button
                                            className="delete-btn"
                                            onClick={(e) => {
                                              e.stopPropagation(); // Prevent triggering the file open on delete click
                                              setFileError("");
                                              handleDelete(index);
                                            }}
                                          >
                                            X
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                              <TextField
                                placeholder="Type your message here..."
                                rows={2}
                                multiline
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    paddingRight: "0px",
                                    border: "none", // Remove border for the input container
                                  },
                                  "& .MuiInputBase-input": {
                                    padding: "0px 10px",
                                    backgroundColor: "#FFF",
                                    borderRadius: "0px",
                                    border: "none", // Remove border for the input itself
                                    fontSize: "12px",
                                    width: "100%",
                                    borderBottomLeftRadius: "4px", // Radius for bottom-left corner
                                    borderBottomRightRadius: "4px",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none", // Remove border for the input container
                                    borderLeft: "1px solid lightgray",
                                    borderRight: "1px solid lightgray",
                                    borderRadius: "0px",
                                  },
                                  // Focus state
                                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none", // Keep no border even when focused
                                      borderLeft: "1px solid lightgray",
                                      borderRight: "1px solid lightgray",
                                      borderRadius: "0px",
                                    },
                                  // Hover state - remove border color
                                  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderLeft: "1px solid lightgray", // Keep the same border when hovered
                                      borderRight: "1px solid lightgray", // Keep the same border when hovered
                                      borderRadius: "0px",
                                    },
                                }}
                                size="small"
                                id="chatInput"
                                type="text"
                                fullWidth
                                className="chatinput"
                                value={newMessage}
                                onChange={(e) => {
                                  const trimmedValue = e.target.value.trim();
                                  if (
                                    trimmedValue ||
                                    e.target.value.length === 0
                                  ) {
                                    setNewMessage(e.target.value);
                                  }
                                }}
                                // onKeyDown={(e) => {
                                //   if (
                                //     e.key === "Enter" &&
                                //     sendcomment === "enable" &&
                                //     newMessage.trim() !== ""
                                //   ) {
                                //     // handleSendMessage();
                                //     // sendchat();
                                //     // setMileStoneModal(false);
                                //     // setTextAreaValues([]);
                                //     // setEnableTextarea(
                                //     //   Array(selectedMileStone.length).fill(
                                //     //     false
                                //     //   )
                                //     // );
                                //     Reuploadfeedback();
                                //     // setEnableTextarea(
                                //     //   Array(selectedMileStone.length).fill(
                                //     //     false
                                //     //   )
                                //     // );
                                //   }
                                // }}
                                // InputProps={{
                                //   endAdornment: (
                                //     <>
                                //       <InputAdornment position="end">
                                //         {/* <Tooltip
                                //           title="Send Change Request"
                                //           position="top"
                                //         >
                                //           <div>
                                //             <Button
                                //               onClick={() => {
                                //                 handleSendMessage();
                                //                 setMileStoneModal(false);
                                //                 setTextAreaValues([]);
                                //                 setEnableTextarea(
                                //                   Array(
                                //                     selectedMileStone.length
                                //                   ).fill(false)
                                //                 );
                                //                 Reuploadfeedback();
                                //                 setEnableTextarea(
                                //                   Array(
                                //                     selectedMileStone.length
                                //                   ).fill(false)
                                //                 );
                                //               }}
                                //               className="btn chatbtn"
                                //               disabled={
                                //                 newMessage.trim() === ""
                                //               }
                                //               sx={{
                                //                 backgroundColor:
                                //                   sendcomment !== "enable"
                                //                     ? "gray"
                                //                     : "#013e6a",
                                //                 textTransform: "none",
                                //                 // height: "38px",
                                //                 height: "auto",
                                //                 color: "white",
                                //                 // padding: "6px 12px",
                                //                 fontSize: "12px",
                                //                 // minWidth: "100px",
                                //                 minWidth: 0,
                                //                 width: "30px",
                                //                 height: "30px",
                                //                 borderRadius: "50%",
                                //                 right: "5px",
                                //                 "&:hover": {
                                //                   backgroundColor:
                                //                     sendcomment !== "enable"
                                //                       ? "darkgray"
                                //                       : "#012a4a",
                                //                 },
                                //                 "&:disabled": {
                                //                   backgroundColor: "lightgray",
                                //                   color: "white",
                                //                 },
                                //               }}
                                //             >
                                //               CR
                                //             </Button>
                                //           </div>
                                //         </Tooltip> */}
                                //       </InputAdornment>

                                //       {/* <InputAdornment position="end">
                                //         <IconButton
                                //         sx={{backgroundColor:'red'}}
                                //           onClick={() => {
                                //             handleSendMessage();
                                //             // sendchat();
                                //             setMileStoneModal(false);
                                //             setTextAreaValues([]);
                                //             setEnableTextarea(
                                //               Array(
                                //                 selectedMileStone.length
                                //               ).fill(false)
                                //             );
                                //             Reuploadfeedback();
                                //             setEnableTextarea(
                                //               Array(
                                //                 selectedMileStone.length
                                //               ).fill(false)
                                //             );
                                //           }}
                                //           className="btn chatbtn mt-1"
                                //           disabled={newMessage.trim() === ""}
                                //           // disabled={sendcomment !== "enable"}
                                //         >
                                //           <SendIcon
                                //             style={{
                                //               color:
                                //                 sendcomment !== "enable"
                                //                   ? "gray"
                                //                   : "#013e6a",
                                //             }}
                                //           />
                                //         </IconButton>
                                //       </InputAdornment> */}
                                //     </>
                                //   ),
                                // }}
                              />
                            </div>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              style={{
                                border: "1px solid lightgray",
                                borderTop: "0px",
                                // borderRadius:files.length===0?"4px":'0px',
                                borderBottomLeftRadius: "4px", // Radius for bottom-left corner
                                borderBottomRightRadius: "4px", // Radius for bottom-right corner
                                border: "1px solid lightgray",
                              }}
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{ zIndex: 1 }}
                              >
                                <Tooltip placement="top" title="Upload a file">
                                  <IconButton
                                    style={{
                                      border: "1px solid lightgray",
                                      margin: "5px",
                                      // padding:'2px'
                                    }}
                                    component="label"
                                  >
                                    <AttachFileIcon
                                      style={{ fontSize: "16px" }}
                                    />
                                    <input
                                      type="file"
                                      accept=".pdf, .txt, image/*, video/*"
                                      hidden
                                      multiple
                                      onChange={handleFileUpload}
                                    />
                                  </IconButton>
                                </Tooltip>
                                {fileError !== "" && (
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "12px",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {fileError}
                                  </span>
                                )}
                              </div>

                              <Tooltip placement="top">
                                <div>
                                  <Button
                                    onClick={() => {
                                      Reuploadfeedback();
                                    }}
                                    className="btn chatbtn"
                                    disabled={newMessage.trim() === ""}
                                    sx={{
                                      backgroundColor:
                                        sendcomment !== "enable"
                                          ? "gray"
                                          : "#013e6a",
                                      textTransform: "none",
                                      height: "auto",
                                      color: "white",
                                      fontSize: "12px",
                                      minWidth: 0,

                                      right: "5px",
                                      "&:hover": {
                                        backgroundColor:
                                          sendcomment !== "enable"
                                            ? "darkgray"
                                            : "#012a4a",
                                      },
                                      "&:disabled": {
                                        backgroundColor: "lightgray",
                                        color: "white",
                                      },
                                    }}
                                  >
                                    Submit to Contractor
                                  </Button>
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              style={{
                background: "white",
                position: "sticky",
                padding: "10px",
                bottom: 0,
                zIndex: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              <div className="mt-2 d-flex justify-content-end">
                {selectedMileStone.length > 0 &&
                  selectedMileStone[0]?.mileStatus === "CR Phase" && (
                    <button
                      className="btn detail-btn me-2 bg-danger text-white"
                      onClick={() => {
                        cancelCRRequest();
                      }}
                      disabled={isLoader}
                    >
                      {isLoader && <span className="round_loader" />}{" "}
                      <span style={{ marginLeft: isLoader ? "5px" : "" }}>
                        CR Deny
                      </span>
                    </button>
                  )}

                {/* check balance */}
                {selectedMileStone.length > 0 &&
                  selectedMileStone[0]?.mileStatus === "CR Phase" &&
                  selectedMileStone[0]?.payout_initiate_status ===
                    "current" && (
                    <button
                      className="btn btn-cvault"
                      onClick={() => {
                        if (
                          finalPaymnet.additional ||
                          !selectedMileStone[0]?.milestone_payout
                        ) {
                          setPaymentModal(true);
                          setMilestoneModel(false);
                          setChangeContract(false);
                        } else if (finalPaymnet.balance) {
                          setPaymentModal(true);
                          setMilestoneModel(false);
                          setChangeContract(false);
                        } else {
                          individualMileStoneAccept(selectedMileStone[0]);
                        }
                      }}
                    >
                      {finalPaymnet.additional ||
                      !selectedMileStone[0]?.milestone_payout
                        ? "Accept & Pay"
                        : finalPaymnet.balance
                        ? "Accept"
                        : "Accept"}
                    </button>
                  )}

                {/* new  */}
                {selectedMileStone.length > 0 &&
                  selectedMileStone[0]?.mileStatus === "Not Started" &&
                  selectedMileStone[0]?.payout_initiate_status === "current" &&
                  !selectedMileStone[0]?.milestone_payout && (
                    <button
                      className="btn btn-cvault"
                      onClick={() => {
                        // Acceptproject();
                        setPaymentModal(true);
                        setMilestoneModel(false);
                        setChangeContract(false);
                        // getFinalPayment();
                      }}
                      // disabled={disabled === "disable"}
                    >
                      {/* {finalPaymnet.balance ? "Accept" : "Accept & Pay"} */}
                      Accept & Pay
                    </button>
                  )}

                {selectedMileStone.length > 0 &&
                  selectedMileStone[0]?.mileStatus === "CR Phase" &&
                  selectedMileStone[0]?.payout_initiate_status === "future" && (
                    // ||
                    //   finalPaymnet.balance !== null ||
                    //   finalPaymnet.additional !== null) && (
                    <button
                      className="btn btn-cvault"
                      onClick={() => {
                        individualMileStoneAccept(selectedMileStone[0]);
                      }}
                      style={{ fontWeight: 400 }}
                    >
                      Accept
                    </button>
                  )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Drawer
        variant="temporary"
        anchor="right" // Drawer on Right Side
        open={ProjectLevelViewModal}
        onClose={() => {
          setProjectLevelViewModal(false);
          setProjectLevelContractorFiles([]);
          setShowDocuments(null);
          setFileError("");
        }}
        sx={{
          width: "50%",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "50%",
            boxSizing: "border-box",
          },
        }}
      >
        <Box sx={{ padding: "10px" }}>
          <div>
            <div className="d-flex justify-content-between mt-1">
              <h4>{docHeader}</h4>
              <IoMdClose
                className="fs-4 cursor"
                onClick={() => {
                  setProjectLevelViewModal(false);
                  setProjectLevelContractorFiles([]);
                  setShowDocuments(null);
                  setFileError("");
                }}
              />
            </div>
            <div className="dropdown-divider"></div>

            {projectLevelContractorFiles?.length !== 0 ? (
              <>
                <div
                  className="grid-container"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
                    gap: "0px",
                    padding: "2px",
                    overflowX: "auto",
                  }}
                >
                  {projectLevelContractorFiles?.map((item, index) => (
                    <div
                      key={index}
                      className="preview-item group relative text-sm text-token-text-primary view_files"
                      style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        background: "#fff",
                        borderRadius: "2px",
                        marginTop: "0px",
                      }}
                    >
                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-xl view_files">
                        <div style={{ textAlign: "center" }}>
                          <Tooltip
                            // title={`Click to view PDF (${item})`}
                            title={`Click to view PDF`}
                            placement="top"
                          >
                            <div
                              style={{ cursor: "pointer" }}
                              className="grid-item"
                              onClick={() => viewFiles(item, true)}
                            >
                              <TextSnippetIcon
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  color: "rgb(128 175 215)",
                                  opacity: "0.9",
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div>
                        {/* File Name */}
                        <div
                          style={{
                            color: "gray",
                            fontSize: "12px",
                            marginTop: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => viewFiles(item, true)}
                        >
                          {(() => {
                            const fileName = item.split("/").pop(); // Extract filename from path
                            if (fileName.length > 9) {
                              return (
                                fileName.replace(/ /g, "").slice(0, 3) +
                                "..." +
                                fileName.replace(/ /g, "").slice(-4)
                              );
                            }
                            return fileName.replace(/ /g, "");
                          })()}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {isLoader && (
                  <div className="mt-2">
                    <div
                      className="text-center mb-3"
                      style={{ fontSize: "13px", color: "#F5AE41" }}
                    >
                      Fetching document from cloud storage. Please wait...
                    </div>

                    <BarLoader
                      color="#F5AE41"
                      width={"80%"}
                      height={5}
                      className="loader"
                      loading={isLoader}
                    />
                  </div>
                )}
                {showDocuments && (
                  <div
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <label className="mb-2" style={{ fontSize: "14px" }}>
                      Selected Document :{" "}
                      <span className="text-primary">
                        {showDocuments.file_name}
                      </span>
                    </label>

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                        showDocuments.file_name
                      ) && (
                        // <img
                        //   src={showDocuments.base64_content}
                        //   style={{
                        //     width: "100%",
                        //     height: "100%",
                        //     objectFit: "cover",
                        //   }}
                        //   alt={showDocuments.file_name}
                        // />
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                    {typeof showDocuments.base64_content === "string" &&
                      /\.(pdf)$/i.test(showDocuments.file_name) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                    {typeof showDocuments.base64_content === "string" &&
                      /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                        showDocuments.file_name
                      ) && (
                        <video
                          style={{ width: "100%", height: "60vh" }}
                          controls
                          src={showDocuments.base64_content}
                        ></video>
                      )}
                  </div>
                )}
                {fileError !== "" && (
                  <div className="text-danger text-center">{fileError}</div>
                )}
              </>
            ) : (
              <div className="text-center mt-4">
                <div
                  style={{
                    background: "aliceblue",
                    width: "max-content",
                    margin: "auto",
                    padding: "20px",
                    borderRadius: "50%",
                  }}
                >
                  <TextSnippetIcon
                    style={{
                      width: "70px",
                      height: "70px",
                      color: "rgb(128 175 215)",
                      opacity: "0.9",
                    }}
                  />
                </div>
                <p className="mt-2" style={{ fontSize: "14px" }}>
                  {" "}
                  No documents have been attached
                </p>
              </div>
            )}
          </div>
        </Box>
      </Drawer>

      <Modal
        open={ownerinformation}
        onClose={() => setownerInformation(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modelStyleowner}>
          {selectedcontractor ? (
            <div>
              <div className="d-flex justify-content-between">
                <h4>Contractor Information</h4>
                <IoMdClose
                  className="fs-4 cursor"
                  onClick={() => {
                    setownerInformation(false);
                  }}
                />
              </div>
              <div className="card-body ownerinfo">
                <div className="row d-flex">
                  <div className="col-md-2">
                    <b>Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-9">
                    {selectedcontractor?.details?.contractor_name}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-2">
                    <b>Phone</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-9">
                    {selectedcontractor?.details?.contact_info ?? "--"}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-2">
                    <b>Email</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-9">
                    {selectedcontractor?.details?.email ?? "--"}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </Modal>
      <Modal
        open={ContractPdf}
        onClose={() => {
          setContractPdf(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            // maxHeight: "100vh", // Ensure the modal does not exceed viewport height
            overflowY: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <div>
                <h5>Project Contract</h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractPdf(false);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedPdfFile && (
                <iframe
                  title="PDF Viewer"
                  style={iframeStyleContractPdf}
                  src={selectedPdfFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={paymentModal}
        // onClose={() => {
        //   setPaymentModal(false);
        //   setFinalPayment({
        //     additional: null,
        //     balance: null,
        //     reminder_message: "",
        //   });
        //   !mileStoneModal ? setChangeContract(true) : setMileStoneModal(true);
        // }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, width: "41%" }}>
          <div>
            <div className="d-flex justify-content-between">
              <h4>Payment Details</h4>
              <IoMdClose
                className="fs-4 cursor"
                onClick={() => {
                  setPaymentModal(false);
                  if (
                    individualMileStone?.row?.status !== "Awaiting Payment" &&
                    individualMileStone?.row?.status !== "Initial Payment"
                  ) {
                    !mileStoneModal
                      ? setChangeContract(true)
                      : setMileStoneModal(true);
                  }
                }}
              />
            </div>
            <div className="dropdown-divider"></div>

            <div className="p-3">
              <>
                <div className="d-flex ">
                  <header
                    style={{
                      fontWeight: "bold",
                      width: finalPaymnet?.previous_milestone_balance_amount
                        ? "50%"
                        : "40%",
                    }}
                  >
                    Project Name{" "}
                  </header>
                  <div>: {changeprojectname}</div>
                </div>
                <div className="d-flex ">
                  <header
                    style={{
                      fontWeight: "bold",
                      width: finalPaymnet?.previous_milestone_balance_amount
                        ? "50%"
                        : "40%",
                    }}
                  >
                    Milestone{" "}
                  </header>
                  {individualMileStone === null ? (
                    <div>
                      :{" "}
                      {individualMileStone
                        ? individualMileStone?.row?.milestone
                        : changeRequestData?.length > 0
                        ? "1. " + changeRequestData[0].milestone_name
                        : ""}
                    </div>
                  ) : (
                    <div>
                      :{" "}
                      {(individualMileStone?.row?.milestone_number || 1) +
                        ". " +
                        individualMileStone?.row?.milestone}{" "}
                    </div>
                  )}
                </div>

                <div className="d-flex ">
                  <header
                    style={{
                      fontWeight: "bold",
                      width: finalPaymnet?.previous_milestone_balance_amount
                        ? "50%"
                        : "40%",
                    }}
                  >
                    Milestone Amount{" "}
                  </header>
                  <div>
                    :{" "}
                    {individualMileStone
                      ? individualMileStone?.row?.milestone_amount.includes("$")
                        ? individualMileStone?.row?.milestone_amount
                            ?.replace("$$", "")
                            .replace(" ", "")
                            .replace(".00", "")
                        : "$" +
                          individualMileStone?.row?.milestone_amount.replace(
                            ".00",
                            ""
                          )
                      : ContractChangeRequest?.length > 0
                      ? ContractChangeRequest[0].milestone_amount.includes("$")
                        ? ContractChangeRequest[0].milestone_amount
                            .replace(".00", "")
                            .replace("$$", "")
                        : "$" +
                          ContractChangeRequest[0].milestone_amount.replace(
                            ".00",
                            ""
                          )
                      : ""}
                  </div>
                </div>
              </>
              {individualMileStone && (
                <div>
                  {finalPaymnet?.balance && (
                    <div className="d-flex ">
                      <header
                        style={{
                          fontWeight: "bold",
                          width: finalPaymnet?.previous_milestone_balance_amount
                            ? "50%"
                            : "40%",
                        }}
                      >
                        Balance Amount
                      </header>
                      <div>
                        : $
                        {Number(finalPaymnet.balance).toLocaleString("en-US")}
                      </div>
                    </div>
                  )}
                  {finalPaymnet?.additional && (
                    <div className="d-flex ">
                      <header
                        style={{
                          fontWeight: "bold",
                          width: finalPaymnet?.previous_milestone_balance_amount
                            ? "50%"
                            : "40%",
                        }}
                      >
                        Additional Amount
                      </header>
                      <div>
                        : $
                        {Number(finalPaymnet?.additional).toLocaleString(
                          "en-US"
                        )}
                      </div>
                    </div>
                  )}

                  {(finalPaymnet?.balance || finalPaymnet?.additional) && (
                    <div className="d-flex ">
                      <header
                        style={{
                          fontWeight: "bold",
                          width: finalPaymnet?.previous_milestone_balance_amount
                            ? "50%"
                            : "40%",
                        }}
                      >
                        Revised Amount
                      </header>
                      <div>
                        : $
                        {(() => {
                          const item =
                            individualMileStone?.row?.milestone_amount || {};

                          const revisedAmount =
                            typeof finalPaymnet?.balance ||
                            finalPaymnet?.additional === "number"
                              ? finalPaymnet?.balance ||
                                finalPaymnet?.additional // Directly use number if already a number
                              : parseFloat(
                                  (
                                    finalPaymnet?.balance ||
                                    finalPaymnet?.additional ||
                                    "0"
                                  ).replace(/[^0-9.e+-]/g, "")
                                ) || 0; // Preserve scientific notation

                          const price =
                            typeof individualMileStone?.row
                              ?.milestone_amount === "number"
                              ? individualMileStone?.row?.milestone_amount
                              : parseFloat(
                                  (
                                    individualMileStone?.row
                                      ?.milestone_amount || "0"
                                  ).replace(/[^0-9.e+-]/g, "")
                                ) || 0;

                          return finalPaymnet?.additional
                            ? Number(revisedAmount + price).toLocaleString(
                                "en-US"
                              )
                            : Number(
                                price - Math.abs(revisedAmount)
                              ).toLocaleString("en-US");
                        })()}
                      </div>
                    </div>
                  )}

                  {finalPaymnet?.previous_milestone_balance_amount && (
                    <div className="d-flex ">
                      <header style={{ fontWeight: "bold", width: "50%" }}>
                        Previous Milestone Balance Amount
                      </header>
                      <div>
                        : $
                        {String(finalPaymnet?.previous_milestone_balance_amount)
                          .replace("$", "")
                          .replace(".00", "")}
                      </div>
                    </div>
                  )}

                  {(finalPaymnet?.balance ||
                    finalPaymnet?.additional ||
                    finalPaymnet?.previous_milestone_balance_amount) &&
                    finalPaymnet?.reminder_message && (
                      <div className="d-flex ">
                        <header
                          style={{
                            fontWeight: "bold",
                            width:
                              finalPaymnet?.previous_milestone_balance_amount
                                ? "50%"
                                : "40%",
                          }}
                        >
                          Message
                        </header>
                        <div
                          style={{
                            width:
                              finalPaymnet?.previous_milestone_balance_amount
                                ? "40%"
                                : "60%",
                          }}
                        >
                          :{" "}
                          {finalPaymnet?.reminder_message
                            .replace("$$", "$")
                            .replace(".00", "")}
                        </div>
                      </div>
                    )}
                </div>
              )}

              <div style={{ marginTop: "10px", color: "#000000" }}>
                {individualMileStone !== null ? (
                  <>
                    Please click the{" "}
                    <span style={{ fontWeight: 500 }}>
                      {" "}
                      {individualMileStone?.milestone_payout &&
                      finalPaymnet.balance
                        ? `"Accept" `
                        : `"Initiate Payment" `}
                    </span>
                    button to proceed.
                  </>
                ) : (
                  <>
                    As per invoice, Please pay{" "}
                    <span style={{ fontWeight: 500 }}>
                      {ContractChangeRequest?.length > 0
                        ? ContractChangeRequest[0].milestone_amount.includes(
                            "$"
                          )
                          ? ContractChangeRequest[0].milestone_amount
                              .replace(".00", "")
                              .replace("$$", "")
                          : "$" +
                            ContractChangeRequest[0].milestone_amount.replace(
                              ".00",
                              ""
                            )
                        : ""}
                    </span>{" "}
                    for Milestone One to proceed.
                  </>
                )}
              </div>
              <div className="row d-flex mt-2">
                <div className="col text-end">
                  <button
                    className="btn btn-cvault"
                    style={{ fontSize: "14px", fontWeight: 400 }}
                    onClick={() => {
                      setLoader(true);
                      if (finalPaymnet?.balance) {
                        if (
                          individualMileStone?.row?.milestone_payout !== null
                        ) {
                          individualMileStoneAccept(selectedMileStone[0]);
                        } else {
                          paymentInitiate();
                        }
                      } else {
                        paymentInitiate();
                      }
                    }}
                    disabled={isLoader}
                  >
                    {isLoader && <span className="round_loader" />}{" "}
                    <span style={{ marginLeft: isLoader ? "5px" : "" }}>
                      {finalPaymnet.balance &&
                      individualMileStone?.row?.milestone_payout !== null
                        ? "Accept"
                        : "Initiate Payment"}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        // className="ms-5"
        anchorOrigin={{
          vertical: "center", // Center vertically
          horizontal: "left", // Align to the right side
        }}
        transformOrigin={{
          vertical: "center", // Center vertically
          horizontal: "right", // Align to the left side
        }}
        style={{ borderRadius: "5px", marginLeft: "-1%" }}
      >
        <Typography style={popoverStyle}>
          <div className="text-center  d-flex justify-content-center h-100 align-items-center ">
            <div>
              <p className="fw-bold fs-6">Milestone(s) Recap</p>
              {Object.entries(count || {}).map(([key, value]) => {
                const spacing =
                  key === "Inspection Phase"
                    ? "22px"
                    : key === "Completed"
                    ? "64px"
                    : "60px";

                return (
                  <span className="admininspection" key={key}>
                    {key}
                    <span style={{ marginLeft: spacing }} />
                    {value}
                  </span>
                );
              })}
            </div>
          </div>
        </Typography>
      </Popover>
      <style>
        {`
        //   .container { text-align: center; }
          .file-upload { margin-bottom: 20px; }
          .upload-btn { padding: 10px 20px; background: #007bff; color: white; cursor: pointer; border-radius: 5px; }
          .preview-container { display: flex; flex-wrap: wrap; gap: 10px; }
          .preview-item { position: relative; text-align: center;margin-top: 5px; }
          .file-name { font-size: 14px; margin-bottom: 5px; color: #333; }
          .preview-img, .preview-video, .preview-pdf { width: 60px; height: 60px; object-fit: fill; border-radius: 5px; }
          .preview-imgs, .preview-videos, .preview-pdfs { width: 100%; height: 100px; object-fit: cover; border-radius: 5px; }
          .delete-btn { position: absolute; top: -5px; right: -5px; background: darkgray; color: white; border: none; cursor: pointer; border-radius: 50%;font-size:8px; width: 1rem;height: 1rem    }
        `}
      </style>

      {/* Modal for File View */}

      <Modal
        open={ContractDocuments}
        onClose={() => {
          setContractDocuments(false);
          setSelectedContractDoc(null); // Reset selected document on close
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <h5>Uploaded Document</h5>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractDocuments(false);
                  setSelectedContractDoc(null);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedContractDoc && (
                <iframe
                  title="PDF Viewer"
                  style={{
                    width: "100%",
                    height: "85vh",
                    border: "none",
                  }}
                  src={selectedContractDoc}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
